import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import '../agStyles.css';
import { Helmet } from 'react-helmet';
import { Toaster, toast } from 'sonner';
import '../antdesigndatestyles.css'
import { useEffect, useState, useMemo, useRef, useCallback } from 'react';
import { Alert, Button as AntButton, DatePicker } from 'antd';
import { collection, query, orderBy, onSnapshot, doc, deleteDoc, getDocs, where, addDoc, serverTimestamp, limit, startAfter } from "firebase/firestore";
import { firestore } from '../firebase';
import getDateString, { analyticsLogError, convertOptionsSymbol, convertToCSV, daysUntilCanceled, combinedDisabledDate, formatNumber, generateCollectionNames, isTradingDay, isTradingHours, triggerCSVDownload, generateDateNames, unpackAndCompleteTrade, formatMoney, miniUnpackAndCompleteTrade, keyMapping, getSectorCode, isMarketHoursEastern } from '../Utils';
import MarketDetailsComponent from './MarketDetailsComponent';
import { CurrentVolumeCellRenderer, DeltaCellRenderer, EndOfDayPerformanceCellRenderer, GuestLockCellRenderer, HighestReturnCellRenderer, HistoricalFlowDateTimeCellRenderer, ImpliedVolatilityCellRenderer, LivePerformanceCellRenderer, OTMCellRenderer, OpenInterestCellRenderer, OptionTypeCellRenderer, PremiumCellRenderer, SigScoreCellRenderer, SpeadExecutionCellRenderer, TickerCellRenderer, TickerSentimentCellRenderer, TradePriceCellRenderer, TradeSizeCellRenderer, TradeTypeCellRenderer, UnixTimestampCellRenderer, useAsyncPerformance } from '../MainDashboardCellRendering';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import FilterIconButton from './FilterIconButton';
import ResetIconButton from './ResetIconButton';
import { TickerSearchBox } from './TickerSearchBox';
import PulsingDot from './PulsingDotComponent';
import QuickFilterAndFavoritesComponent from './ChipFilterComponent';
import CallPutCheckBoxes from '../CallPutCheckBoxes';
import SentimentCheckboxes from '../DashboardComponents/SentimentCheckboxes';
import TradesSweepsCheckBoxes from '../TradesSweepsCheckBoxes';
import ExecutionPriceCheckboxes from '../ExecutionPriceCheckboxes';
import PremiumFilter from '../PremiumFilter';
import ScoreFilterFields from '../ScoreFields';
import TickerFilter from '../TickerFilterFields';
import ExpirationFilterFields from '../ExpirationFilterFields';
import OTMFilterFields from '../OTMFilterFields';
import SpotPriceFields from '../SpotPriceFields';
import OptionPriceFields from '../OptionPriceFields';
import MarketCapFields from '../MarketCapFields';
import CurrentVolumeFilter from '../DashboardComponents/CurrentVolumeFilter';
import OIFilter from '../DashboardComponents/OIFilter';
import addEventToFirestore from '../EventHelper';
import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, Progress, Select, SelectItem, Tab, Tabs } from '@nextui-org/react';
import AlertsListView from '../AlertsListView';
import { BarChart, FileText, Gem, LineChartIcon, Crosshair, NewspaperIcon, Star, Search, Download, ArrowUpDown } from 'lucide-react';
import Sidebar from '../Sidebar';
import TextButton from '../components/ui/BullflowTextButton';
import { GenericSearchBox } from './GenericSearchBox';
import TradingViewWidget from '../DashboardComponents/TradingViewWidget';
import { Dialog, DialogContent, styled } from '@material-ui/core';
import OptionPriceChart from '../OptionPriceChart';
import NoSubTopBarComponent from './NoSubTopBarComponent';
import { Tooltip } from "@nextui-org/react";
import SoundIconButton from './SoundIconButton';
import { useMediaQuery } from 'react-responsive';
import Bull from '../bullflow_3.png';
import ClearIsolatedContractButton from './ClearIsolatedContractButton';
import { addUserFavTicker } from '../FirestoreFunctions/Functions';
import TradeSizeFields from '../DashboardComponents/TradeSizeFilter';
import DownloadIconButton from './DownloadIconButton';
import axios from 'axios';
import NetPremiumChart from '../NetPremiumChart';
import { min } from 'moment';
import { set } from 'react-ga';
import VolumeOfInterestFilter from '../DashboardComponents/VolumeOfInterestFilter';
import SectorDropDown from '../SectorDropdown';
import debounce from 'lodash/debounce';
import ImpliedVolatilityFields from '../ImpliedVolatilityFields';
import StrikePriceFields from '../StrikePriceFields';

const actualToday = new Date();
const MAX_LAST_7_DAYS_BF_VOLUME = 500;
const MAX_PREV_DAY_BF_VOLUME = 250;
const MAX_PREVIOUS_VOLUME = 1000000;
const MAX_CURRENT_VOLUME = 1000000;
const MAX_DTE = 2000;
const MAX_SPOT_PRICE = 10000;
const MAX_STRIKE_PRICE = 10000;
const MAX_IMPLIED_VOLATILITY = 500;
const MAX_PREMIUM = 5_000_000_000;
const MAX_OI = 1000000;
const secondsCalc = (1000 * 3600 * 24);
const HIGH_VOLUME_TICKERS_SET = new Set(["GLD", "IWM", "QQQ", "SLV", "SMH", "SOXL", "SOXS", "SPX",
    "SPXW", "SPY", "SQQQ", "TLT", "TQQQ", "VIX", "XLF", "TSLA", "NVDA"])
const SLOW_MODE_SPREAD_EXECUTIONS = new Set(["Mid", "Bid", "Below Bid"])
const sectors = ["ALL", "Industrials", "Financial Services", "Consumer Cyclical", "Real Estate", "Basic Materials", "Other", "Technology", "Energy", "Consumer Defensive", "Communication Services", "Healthcare", "Utilities"]
const gridOptions = {
    getRowNodeId: data => data.id,
    getRowId: params => params.data.id,
    headerHeight: 20, // Set the header row height to 50 pixels
};
const MyDialog = styled(Dialog)({
    '& .MuiDialog-paper': {
        backgroundColor: 'black',
        borderRadius: '10px',
        minWidth: '300px',
        maxWidth: '90%',
        width: 'auto',
        height: 'auto',
        overflowY: 'auto',
        zIndex: 10000
    },
});

function UpdatedHistoricalFlowDashboard() {
    const navigate = useNavigate();
    const auth = getAuth();
    const { RangePicker } = DatePicker;
    const user = auth.currentUser;
    const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false);
    const [isTrendingAlertsOpen, setIsTrendingAlertsOpen] = useState(false);
    const toggleDrawer = () => setIsFilterDrawerOpen(!isFilterDrawerOpen);
    const [trades, setTrades] = useState([]);
    const isMountedRef = useRef(true);
    const processedTradeIdsRef = useRef(new Set());
    const [openNetPremiumChart, setOpenNetPremiumChart] = useState(false);
    const unsubscribeRef = useRef(null);
    const [selectedRowData, setSelectedRowData] = useState(null);
    const setProcessedTradeIds = useCallback((newSet) => {
        processedTradeIdsRef.current = newSet;
    }, []);
    const gridApiRef = useRef(null);
    const columnApiRef = useRef(null);
    const myDivRef = useRef();
    const [localFavoritesList, setLocalFavoritesList] = useState([]);
    const [expirationUnixStart, setExpirationUnixStart] = useState(0);
    const [expirationUnixEnd, setExpirationUnixEnd] = useState(9999999999999);
    const [isolatedSymbol, setIsolatedSymbol] = useState("");
    const [minPremium, setMinPremium] = useState(9999);
    const [maxPremium, setMaxPremium] = useState(MAX_PREMIUM);
    const [excludeTickers, setExcludeTickers] = useState([]);
    const [onlyShowTickers, setOnlyShowTickers] = useState([]);
    const [minDTE, setMinDTE] = useState(0);
    const [maxDTE, setMaxDTE] = useState(MAX_DTE);
    const [minOTM, setMinOTM] = useState(-3000);
    const [maxOTM, setMaxOTM] = useState(3000);
    const [minScore, setMinScore] = useState(0.0);
    const [maxScore, setMaxScore] = useState(1.0);
    const [minVolumeOfInterest, setMinVolumeOfInterest] = useState(0);
    const [maxVolumeOfInterest, setMaxVolumeOfInterest] = useState(100);
    const [minCurrentVolume, setMinCurrentVolume] = useState(0);
    const [maxCurrentVolume, setMaxCurrentVolume] = useState(MAX_CURRENT_VOLUME);
    const [minOI, setMinOI] = useState(0);
    const [maxOI, setMaxOI] = useState(MAX_OI);
    const [fetchingRemainingTrades, setFetchingRemainingTrades] = useState(false);
    const [minSpot, setMinSpot] = useState(0);
    const [maxSpot, setMaxSpot] = useState(7500);
    const [minStrike, setMinStrike] = useState(0);
    const [maxStrike, setMaxStrike] = useState(MAX_STRIKE_PRICE);
    const [minIV, setMinIV] = useState(0);
    const [maxIV, setMaxIV] = useState(MAX_IMPLIED_VOLATILITY);
    const [isSoundOn, setIsSoundOn] = useState(true);
    const [isSlowMode, setIsSlowMode] = useState(false);
    const [minOptionPrice, setMinOptionPrice] = useState(0);
    const [maxOptionPrice, setMaxOptionPrice] = useState(1000000);
    const [minTradeSize, setMinTradeSize] = useState(0);
    const [maxTradeSize, setMaxTradeSize] = useState(1000000);
    const [minVolumeDif, setMinVolumeDif] = useState(null);
    const [maxVolumeDif, setMaxVolumeDif] = useState(null);
    const [minMarketCap, setMinMarketCap] = useState(0);
    const [maxMarketCap, setMaxMarketCap] = useState(99999999999999);
    const [tradeInfoDialog, setTradeInfoDialog] = useState(false);
    const [openSaveDialog, setOpenSaveDialog] = useState(false);
    const [openSaveAlertDialog, setOpenSaveAlertDialog] = useState(false);
    const [openOptionPriceChart, setOpenOptionPriceChart] = useState(false);
    const [openSpotTradingView, setOpenSpotTradingView] = useState(false);
    const [tradingViewTicker, setTradingViewTicker] = useState("");
    const [optionPriceChartTicker, setOptionPriceChartTicker] = useState("");
    const [accountSettingsDialog, setAccountSettingsDialog] = useState(false);
    const [callsCheckBox, setCallsCheckBox] = useState(true);
    const [putsCheckBox, setPutsCheckBox] = useState(true);
    const [aaCheckBox, setAACheckBox] = useState(true);
    const [bbCheckBox, setBBCheckBox] = useState(true);
    const [bullishCheckBox, setBullishCheckBox] = useState(true);
    const [bearishCheckBox, setBearishCheckBox] = useState(true);
    const [neutralCheckBox, setNeutralCheckBox] = useState(true);
    const [spCheckBox, setSpCheckBox] = useState(true);
    const [splitsCheckBox, setSplitsCheckBox] = useState(true);
    const [sweepsCheckBox, setSweepsCheckBox] = useState(true);
    const [blocksCheckbox, setBlocksCheckBox] = useState(true);
    const [multilegCheckbox, setMultilegCheckbox] = useState(false);
    const [singlesCheckbox, setSinglesCheckBox] = useState(true);
    const [filterNameValue, setFilterNameValue] = useState("");
    const [alertNameValue, setAlertNameValue] = useState("");
    const [selectedTickerForInfo, setSelectedTickerForInfo] = useState(null);
    const [exDividendCheckbox, setExDividendCheckBox] = useState(false);
    const [filterItems, setFilterItems] = useState([]);
    const [alertItems, setAlertItems] = useState([]);
    const alertItemsRef = useRef({});
    const [selectedItem, setSelectedItem] = useState("Filters");
    const [filterNames, setFilterNames] = useState([]);
    const [userHasSubscription, setUserHasSubscription] = useState(true);
    const [alreadyDeterminedUserSubscriptionState, setAlreadyDeterminedUserSubscriptionState] = useState(false);
    const [contractPercentChange, setContractPercentChange] = useState(null);
    const [contractPreviousVolume, setContractPreviousVolume] = useState(null);
    const [contractBidAskSpread, setContractBidAskSpread] = useState(["", "", ""]);
    const [contractCurrentValue, setContractCurrentValue] = useState(null);
    const [tradeDetailsData, setTradeDetailsData] = useState(null);
    const [sectorFilterCode, setSectorFilterCode] = useState("12");
    const [isFiltering, setIsFiltering] = useState(false);
    const [filtersHidden, setFiltersHidden] = useState(false);
    const [showAlertsView, setShowAlertsView] = useState(false);
    const [cancelAt, setCancelAt] = useState(null);
    const [activeTags, setActiveTags] = useState([]);
    const [activeFavoriteTickers, setActiveFavoriteTickers] = useState([]);
    const [volOverOI, setVolOverOI] = useState(false);
    const [searchInputValue, setSearchInputValue] = useState("");
    const [tickerListSearchValue, setTickerListSearchValue] = useState("");
    const [showRowDropdown, setShowRowDropdown] = useState(false);
    const [dropdownPosition, setDropdownPosition] = useState({ x: 0, y: 0 });
    const [tickerForData, setTickerForData] = useState("");
    const [isSearching, setIsSearching] = useState(false);
    const [filterSelectValue, setFilterSelectValue] = useState("");
    const [firstTimeLoading, setFirstTimeLoading] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isScrollPositionTop, setIsScrollPositionTop] = useState(true);
    const [expirationStartDate, setExpirationStartDate] = useState(null);
    const [expirationEndDate, setExpirationEndDate] = useState(null);
    const [collectionList, setCollectionList] = useState([]);
    const [dateStringList, setDateStringList] = useState([]);
    const [fetchCollectionProgress, setFetchCollectionProgress] = useState(0);
    const [hasSelectedDateRange, setHasSelectedDateRange] = useState(false);
    const [currentCallPutData, setCurrentCallPutData] = useState({
        calls: 0,
        puts: 0,
        callPremium: 0,
        putPremium: 0,
    });
    const lastScrollTopRef = useRef(0);
    const gridDivRef = useRef(null);
    const gridStyle = useMemo(() => ({
        height: 'calc(100vh - 20px)', width: '100%', transition: 'all 0.3s ease', marginTop: '10px',
        overflow: 'hidden'
    }), []);
    const showSignupNotif = () => {
        toast('Start your free trial to access this feature', {
            duration: 7500,
            style: {
                background: 'black',
                color: 'white',
            },
            action: {
                label: 'Let\'s Go',
                onClick: () => navigate('/signup'),
            },
            icon: <Gem size={18} />,
        });
    };
    const onRowClicked = (params) => {
        const rowData = params.data;
        setSelectedRowData(rowData);
        setShowRowDropdown(true);
        window.gtag('event', 'Click trade row', {
            'event_category': 'Button',
            'event_label': 'Click trade row',
            'value': 1
        });
        addEventToFirestore("Click trade row", user && user.email ? user.email : "N/A");
        // Get the viewport height
        const viewportHeight = window.innerHeight;

        // Calculate the distance from the bottom of the screen
        const distanceFromBottom = viewportHeight - params.event.clientY;

        // Set a threshold value for the distance from the bottom
        const threshold = 300; // Adjust this value according to your needs

        // If the distance from the bottom is less than the threshold, move the dropdown up
        if (distanceFromBottom < threshold) {
            setDropdownPosition({
                x: params.event.clientX,
                y: params.event.clientY - threshold,
            });
        } else {
            setDropdownPosition({
                x: params.event.clientX,
                y: params.event.clientY,
            });
        }
    };

    const closeRowDropdown = () => {
        setShowRowDropdown(false);
    };

    function tradePriceClickHandler(gtag, addEventToFirestore, setOpenOptionPriceChart, setOptionPriceChartTicker, params) {
        gtag('event', 'Click trade price', {
            'event_category': 'Button',
            'event_label': 'Click trade price',
            'value': 1
        });
        addEventToFirestore("Open option volume chart");
        setOpenOptionPriceChart(true);
        setOptionPriceChartTicker(params.row.sym);
    };

    function openNetPremiumHandler(gtag, addEventToFirestore, setOpenNetPremiumChart, setOptionPriceChartTicker, params) {
        gtag('event', 'Click net premium', {
            'event_category': 'Button',
            'event_label': 'Click net premium',
            'value': 1
        });
        addEventToFirestore("Open Net Premium Chart");
        setOpenNetPremiumChart(true);
        setOptionPriceChartTicker(params.row.sym);
    };

    function spotClickHandler(gtag, addEventToFirestore, setOpenSpotTradingView, setTradingViewTicker, params) {
        gtag('event', 'Click spot price', {
            'event_category': 'Button',
            'event_label': 'Click spot price',
            'value': 1
        });
        addEventToFirestore("Open Trading View Chart");
        setOpenSpotTradingView(true);
        setTradingViewTicker(params.row.tsy);
    }

    const onTradePriceClick = useCallback((params) => () => {
        tradePriceClickHandler(window.gtag, addEventToFirestore, setOpenOptionPriceChart, setOptionPriceChartTicker, params);
    }, [addEventToFirestore, setOpenOptionPriceChart, setOptionPriceChartTicker]);

    const onNetPremiumChartClicked = useCallback((params) => () => {
        openNetPremiumHandler(window.gtag, addEventToFirestore, setOpenNetPremiumChart, setOptionPriceChartTicker, params);
    }, [addEventToFirestore, setOpenOptionPriceChart, setOptionPriceChartTicker]);

    const openTradingViewChart = useCallback((params) => {
        spotClickHandler(window.gtag, addEventToFirestore, setOpenSpotTradingView, setTradingViewTicker, params);
    }, [addEventToFirestore, setOpenSpotTradingView, setTradingViewTicker]);

    const DropdownMenu = ({ position, onClose }) => {
        const dropDownItems = [
            { key: "isolateStock", label: "Isolate Ticker", icon: <Search size={16} /> },
            { key: "isolate", label: "Isolate Contract", icon: <Crosshair size={16} /> },
            { key: "favorite", label: "Favorite Ticker", icon: <Star size={16} /> },
            {
                key: "favoritecontract",
                label: "Favorite Contract",
                icon: (
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="12"
                        viewBox="0 0 20 20"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-binoculars"
                    >
                        <path d="M10 10h4" />
                        <path d="M19 7V4a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v3" />
                        <path d="M20 21a2 2 0 0 0 2-2v-3.851c0-1.39-2-2.962-2-4.829V8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v11a2 2 0 0 0 2 2z" />
                        <path d="M22 16L2 16" />
                        <path d="M4 21a2 2 0 0 1-2-2v-3.851c0-1.39 2-2.962 2-4.829V8a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v11a2 2 0 0 1-2 2z" />
                        <path d="M9 7V4a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v3" />
                    </svg>
                )
            },
            { key: "chart", label: "Option Chart", icon: <BarChart size={16} /> },
            { key: "details", label: "Trade Details", icon: <FileText size={16} /> },
            { key: "news", label: "News", icon: <NewspaperIcon size={16} /> },
            { key: "ticker chart", label: "TradingView Chart", icon: <LineChartIcon size={16} /> },
            { key: "netpremium", label: "Net Premium Chart", icon: <ArrowUpDown size={16} /> },
        ];
        // Extract the "chart" item and split the rest.
        const chartItem = dropDownItems.find(item => item.key === "chart");
        const halfIndex = Math.ceil(dropDownItems.length / 2);
        // Remove the "chart" item from both halves.
        const leftItems = dropDownItems.slice(0, halfIndex).filter(item => item.key !== "chart");
        const rightItems = dropDownItems.slice(halfIndex).filter(item => item.key !== "chart");
        // Add the chart item to the bottom of the right column.
        if (chartItem) leftItems.push(chartItem);
        const handleItemClick = (item) => {
            if (userHasSubscription === false) {
                showSignupNotif();
                onClose();
                return;
            }
            switch (item.key) {
                case "details":
                    openTradeInfo(selectedRowData);
                    break;
                case "netpremium":
                    onNetPremiumChartClicked({ row: selectedRowData })();
                    break;
                case "chart":
                    onTradePriceClick({ row: selectedRowData })();
                    break;
                case "news":
                    window.open(`https://www.benzinga.com/quote/${selectedRowData.tsy}/news`, '_blank');
                    break;
                case "ticker chart":
                    openTradingViewChart({ row: selectedRowData });
                    break;
                case "isolate":
                    gridApiRef.current.ensureIndexVisible(0, 'top');
                    setIsolatedSymbol(selectedRowData.sym);
                    break;
                case "favorite":
                    addUserFavTicker(user.email, selectedRowData.tsy);
                    setLocalFavoritesList([...localFavoritesList, selectedRowData.tsy]);
                    break;
                case "favoritecontract":
                    addUserFavTicker(user.email, selectedRowData.sym);
                    setLocalFavoritesList([...localFavoritesList, selectedRowData.sym]);
                    break;
                case "isolateStock":
                    gridApiRef.current.ensureIndexVisible(0, 'top');
                    setIsolatedSymbol("");
                    setTickerForData(selectedRowData.tsy);
                    setOnlyShowTickers([selectedRowData.tsy]);
                    setSearchInputValue(selectedRowData.tsy);
                    break;
                default:
                    break;
            }
            onClose();
        };

        const MenuItem = ({ item }) => {
            const [isHovered, setIsHovered] = useState(false);

            const iconButtonStyle = {
                // frosted glass base
                background: 'rgba(255, 255, 255, 0.15)',        // light frost layer
                backdropFilter: 'blur(8px)',                   // blur the backdrop
                WebkitBackdropFilter: 'blur(8px)',             // Safari
                border: '1px solid rgba(255, 255, 255, 0.25)',  // subtle highlight edge
                padding: '8px 12px',
                borderRadius: '90px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                fontSize: '13px',
                fontWeight: 550,
                cursor: 'pointer',
                transition: 'background 0.3s ease, box-shadow 0.3s ease',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.5)',

                marginBottom: '10px',
            };


            return (
                <div
                    style={iconButtonStyle}
                    onClick={() => handleItemClick(item)}
                >
                    <span style={{ marginRight: '8px' }}>{item.icon}</span>
                    {item.label}
                </div>
            );
        };

        const closeButtonStyle = {
            backgroundColor: '#1f2026',
            border: 'none',
            borderRadius: '50%',
            width: '20px',
            height: '20px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'background-color 0.3s ease, box-shadow 0.3s ease',
            boxShadow: '0px 2px 3px rgba(0, 0, 0, 0.3)',
            padding: 0,
            margin: 0,
            fontSize: '10px',
        };


        return (
            <div
                style={{
                    position: 'absolute',
                    top: position.y,
                    left: position.x,
                    background: 'rgba(0, 0, 0, 0.25)',           // glassy dark tint
                    backdropFilter: 'blur(12px)',               // blur backdrop
                    WebkitBackdropFilter: 'blur(12px)',         // Safari support
                    border: '1px solid rgba(255, 255, 255, 0.15)',
                    borderRadius: '16px',
                    padding: '0 20px 20px 20px',
                    boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
                    color: 'white',
                    zIndex: 100,
                    fontWeight: 550,
                    minWidth: '250px',
                }}
            >
                {/* Header with Symbol and Close Button */}
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '12px',
                        paddingTop: '10px',
                    }}
                >
                    <p
                        style={{
                            color: '#8c8c8c',
                            fontSize: '12px',
                            fontStyle: 'italic',
                            margin: 0,
                            opacity: 0.0,
                        }}
                    >
                        {selectedRowData.sym}
                    </p>
                    <button
                        onClick={onClose}
                        style={{
                            ...closeButtonStyle,
                            backgroundColor: '#292a30',
                            boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.5)'
                        }}
                        aria-label="Close Dropdown"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="12"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <line x1="18" y1="6" x2="6" y2="18" />
                            <line x1="6" y1="6" x2="18" y2="18" />
                        </svg>
                    </button>
                </div>

                {/* Menu Items */}
                <div
                    style={{
                        display: 'grid',
                        gridTemplateColumns: '1fr auto 1fr',
                        columnGap: '10px',
                        alignItems: 'flex-start',
                    }}
                >
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        {leftItems.map((item) => (
                            <MenuItem key={item.key} item={item} />
                        ))}
                    </div>

                    {/* Divider */}
                    <div style={{ backgroundColor: '#3a3a3a', width: '1px', height: '100%' }} />

                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        {rightItems.map((item) => (
                            <MenuItem key={item.key} item={item} />
                        ))}
                    </div>
                </div>
            </div>
        );
    };




    function debounce_manual(func, wait) {
        let timeout;
        return function (...args) {
            const context = this;
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(context, args), wait);
        };
    }



    const [columnDefs, setColumnDefs] = useState([
        {
            field: 'ut',
            width: 135,
            headerName: 'Time',
            suppressMenu: true,
            cellRenderer: HistoricalFlowDateTimeCellRenderer,
            sort: 'desc',
            editable: false,
        },
        {
            field: 'p', headerName: 'Value', width: 85,
            editable: false,
            cellRenderer: PremiumCellRenderer
        },
        {
            field: 'tsy', headerName: 'Ticker', cellRenderer: TickerCellRenderer,
            width: 92.5,
            cellStyle: { fontSize: '11px', fontWeight: 600 },
            suppressMenu: true,
            editable: false,
        },
        {
            field: 'sp', headerName: 'Spot', width: 85,
            editable: false,
        },
        {
            field: 'stp', headerName: 'Strike', width: 75,
            suppressMenu: true,
            editable: false,
        },
        {
            field: 'ot', headerName: 'P/C',
            cellRenderer: OptionTypeCellRenderer, width: 72.5,
            editable: false,
        },
        {
            field: 'ed', headerName: 'Expiration',
            width: 115,
            editable: false,
        },
        {
            field: 'se', headerName: 'X', width: 80,
            editable: false,
            cellRenderer: SpeadExecutionCellRenderer
        },
        {
            field: 'tt', headerName: 'Type',
            width: 80,
            cellRenderer: TradeTypeCellRenderer,
            editable: false,
        },
        {
            field: 'tp', headerName: 'Price',
            width: 85,
            editable: false,
        },
        {
            field: 'ts', headerName: 'Size',
            editable: false,
            cellRenderer: TradeSizeCellRenderer,
            width: 75
        },
        {
            field: 'sc', headerName: 'SigScore', width: 107.5,
            editable: false,
            cellRenderer: SigScoreCellRenderer
        },
        {
            field: 'lp', headerName: '% Return', width: 125,
            sortable: false,
            editable: false, cellRenderer: LivePerformanceCellRenderer
        },
        {
            field: 'cv', headerName: 'Volume', width: 95,
            editable: false,
            cellRenderer: CurrentVolumeCellRenderer
        },
        {
            field: 'oi', headerName: 'OI', width: 70,
            editable: false,
            cellRenderer: OpenInterestCellRenderer
        },
        {
            field: 'iv', headerName: 'IV', width: 70,
            editable: false,
            cellRenderer: ImpliedVolatilityCellRenderer
        },
        {
            field: 'op', headerName: 'OTM', width: 80,
            editable: false,
            cellRenderer: OTMCellRenderer
        },
        {
            field: 'tks', headerName: 'Sentiment',
            width: 100, suppressMenu: true, wrapHeaderText: true,
            cellRenderer: TickerSentimentCellRenderer, editable: false,
        },
        {
            field: 'eod', headerName: 'Daily High', width: 160,
            editable: false,
            cellRenderer: EndOfDayPerformanceCellRenderer
        },
        {
            field: 'edf', headerName: 'Earnings', width: 110,
            editable: false, sortable: false, suppressMenu: true,
        },
    ]);

    const highestReturnColDefs = [
        {
            field: 'ut',
            width: 135,
            headerName: 'Time',
            suppressMenu: true,
            cellRenderer: HistoricalFlowDateTimeCellRenderer,
            sort: 'desc',
            editable: false,
        },
        {
            field: 'p', headerName: 'Value', width: 85,
            editable: false,
            cellRenderer: PremiumCellRenderer
        },
        {
            field: 'tsy', headerName: 'Ticker', cellRenderer: TickerCellRenderer,
            width: 92.5,
            cellStyle: { fontSize: '11px', fontWeight: 600 },
            suppressMenu: true,
            editable: false,
        },
        {
            field: 'sp', headerName: 'Spot', width: 85,
            editable: false,
        },
        {
            field: 'stp', headerName: 'Strike', width: 75,
            suppressMenu: true,
            editable: false,
        },
        {
            field: 'ot', headerName: 'P/C',
            cellRenderer: OptionTypeCellRenderer, width: 72.5,
            editable: false,
        },
        {
            field: 'ed', headerName: 'Expiration',
            width: 115,
            editable: false,
        },
        {
            field: 'se', headerName: 'X', width: 80,
            editable: false,
            cellRenderer: SpeadExecutionCellRenderer
        },
        {
            field: 'tt', headerName: 'Type',
            width: 80,
            cellRenderer: TradeTypeCellRenderer,
            editable: false,
        },
        {
            field: 'tp', headerName: 'Price',
            width: 85,
            editable: false,
        },
        {
            field: 'ts', headerName: 'Size',
            editable: false,
            cellRenderer: TradeSizeCellRenderer,
            width: 75
        },
        {
            field: 'sc', headerName: 'SigScore', width: 107.5,
            editable: false,
            cellRenderer: SigScoreCellRenderer
        },
        {
            field: 'highestReturn', headerName: 'Peak Return', width: 125,
            sortable: false, suppressMenu: true,
            editable: false, cellRenderer: HighestReturnCellRenderer
        },
        {
            field: 'cv', headerName: 'Volume', width: 95,
            editable: false,
            cellRenderer: CurrentVolumeCellRenderer
        },
        {
            field: 'oi', headerName: 'OI', width: 70,
            editable: false,
            cellRenderer: OpenInterestCellRenderer
        },
        {
            field: 'iv', headerName: 'IV', width: 70,
            editable: false,
            cellRenderer: ImpliedVolatilityCellRenderer
        },
        {
            field: 'op', headerName: 'OTM', width: 80,
            editable: false,
            cellRenderer: OTMCellRenderer
        },
        {
            field: 'tks', headerName: 'Sentiment',
            width: 100, suppressMenu: true, wrapHeaderText: true,
            cellRenderer: TickerSentimentCellRenderer, editable: false,
        },
        {
            field: 'edf', headerName: 'Earnings', width: 110,
            editable: false, sortable: false, suppressMenu: true,
        },
        {
            field: 'eod', headerName: 'Daily High', width: 160,
            editable: false,
            cellRenderer: EndOfDayPerformanceCellRenderer
        },
    ];



    const defaultColDef = useMemo(() => {
        return {
            editable: true,
            filter: true,
        };
    }, []);

    useEffect(() => {
        // Subscribe to auth changes
        if (!isMarketHoursEastern()) {
            setColumnDefs(highestReturnColDefs);
        }
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                if (!alreadyDeterminedUserSubscriptionState) {
                    fetchSubscriptionType(user);
                }
            } else {
                setUserHasSubscription(false);
                setColumnDefs(columnDefs);
            }
        });
        return () => unsubscribe();
    }, []);

    const fetchSubscriptionType = async (user_) => {
        try {
            if (user_ != null) {
                const paymentsCollection = collection(firestore, 'payments');
                const q = query(paymentsCollection, where('user', '==', user_.email));
                const querySnapshot = await getDocs(q);
                // gridApiRef.current.showLoadingOverlay();
                if (querySnapshot.empty) {
                    console.log(`Error 5988, user does not have a subscription. User: ${user_.email}`);
                    setUserHasSubscription(false);
                    setColumnDefs(columnDefs);
                    gridApiRef.current.hideOverlay();
                } else {
                    querySnapshot.forEach((doc) => {
                        let subtype = doc.data().subscriptionType;
                        let canceling = doc.data().canceling;
                        let cancelAt_ = doc.data().cancelAt;
                        let subscriptionStatus = doc.data().subscriptionStatus;
                        if (cancelAt_ != null && canceling != null) {
                            const daysUntilCanceled_ = daysUntilCanceled(cancelAt_);
                            if (canceling === true && daysUntilCanceled_ <= 14) {
                                setCancelAt(daysUntilCanceled_);
                            }
                        }
                        if (subscriptionStatus != null && (subscriptionStatus === "deleted" || subscriptionStatus === "canceled" || subscriptionStatus === "incomplete_expired" || subscriptionStatus === "incomplete" || subscriptionStatus === "past_due" || subscriptionStatus === "unpaid")) {
                            navigate('/pricing');
                        }

                        if (subscriptionStatus != null && (subscriptionStatus === "deleted" || subscriptionStatus === "canceled" || subscriptionStatus === "incomplete_expired" || subscriptionStatus === "incomplete" || subscriptionStatus === "past_due" || subscriptionStatus === "unpaid")) {                            // Open stripe portal
                            navigate('/pricing');
                        }
                        if (subtype != null && (subtype === "yearly" || subtype === "monthly")) {
                            setUserHasSubscription(true);
                            setAlreadyDeterminedUserSubscriptionState(true);
                        } else {
                            setUserHasSubscription(false);
                            setColumnDefs(columnDefs);
                        }
                    });
                }
            } else {
                console.error("error code 19277");
            }
        } catch (error) {
            console.error(`Sub error 391174`);
        }
    };
    useEffect(() => {
        if (user != null) {
            fetchFilters();
            fetchAlerts();
        }
        addEventToFirestore("Dashboard loaded");
    }, [user]);
    const fetchData = useCallback(async (symbol, tradePrice) => {
        setContractPercentChange("N/A");
        setContractCurrentValue("N/A");
        const data = await fetchPercentReturn(symbol, tradePrice);
        try {
            setContractPercentChange(data[0]);
            setContractCurrentValue(data[1]);
        } catch (error) {
            console.log("Spread error 10062");
            setContractPercentChange("N/A");
            setContractCurrentValue("N/A");
        }
    }, []);
    const fetchPreviousVolumeData = useCallback(async (symbol) => {
        setContractPreviousVolume("N/A");
        const data = await fetchPreviousVolume(symbol);
        try {
            // Check if the data[0] is a number
            if (typeof data[0] === 'number') {
                console.log("Got previous volume: ", data[0]);
                setContractPreviousVolume(data[0]);
            } else {
                console.log("prev volume error 10061");
                setContractPreviousVolume("N/A");
            }
        } catch (error) {
            console.log("prev volume error 10062");
            setContractPreviousVolume("N/A");
        }
    }, []);

    const fetchTradeDetailsData = useCallback(async (symbol, x, docId) => {
        setTradeDetailsData(null);
        const data = await fetchTradeDetails(symbol, x, docId);
        try {
            setTradeDetailsData(data);
        } catch (error) {
            console.log("Trade details error 29852");
            setTradeDetailsData(null);
        }
    }, []);

    const fetchContractBidAsk = useCallback(async (symbol) => {
        setContractBidAskSpread(["N/A", "N/A", "N/A"]);
        const data = await fetchBidAskSpread(symbol);
        try {
            if (data.length === 3) {
                console.log("Got bid ask: ", data);
                setContractBidAskSpread(data);
            } else {
                console.log("Bid ask error 47221");
                setContractBidAskSpread(["N/A", "N/A", "N/A"]);
            }
        } catch (error) {
            console.log("Bid ask error 47222");
            setContractBidAskSpread(["N/A", "N/A", "N/A"]);
        }
    }, []);



    const openTradeInfo = (trade) => {
        setSelectedTickerForInfo(trade);
        fetchData(trade.sym, trade.tp)
        fetchTradeDetailsData(trade.sym, trade.x);
        setTradeInfoDialog(true);
    };
    const fetchAlerts = async () => {
        try {
            if (user != null) {
                const querySnapshot = await getDocs(query(
                    collection(firestore, '_custom_alerts'),
                    where('userEmail', '==', user.email))
                );
                let fetchedItems = {};
                querySnapshot.forEach(doc => {
                    const data = doc.data();
                    fetchedItems[data.alertName] = data;
                });

                setAlertItems(fetchedItems); // Update state
                alertItemsRef.current = fetchedItems;
            } else {
                console.log("Alert error 6574839");
            }
        } catch (error) {
            console.error('Alert error 3391855: ', error);
        }
    };
    function generateRandomChar() {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz_-';
        return chars[Math.floor(Math.random() * chars.length)];
    }

    function generateID() {
        let id = '';
        for (let i = 0; i < 7; i++) {
            id += generateRandomChar();
        }
        return id;
    }
    const fetchTrades = useCallback(async (ticker = "") => {
        // console.log("Fetching trades, ticker: ", ticker);
        if (dateStringList.length > 0) {
            setTrades([]);
            setLoading(true);
            setIsLoading(true);
            setFetchCollectionProgress(0);
            setFirstTimeLoading(true);
            const dateListLength = dateStringList.length;
            let iteration = 0;
            let temptTickerListSearchValue = ticker;
            if (ticker === "") {
                temptTickerListSearchValue = tickerListSearchValue;
            } else {
                temptTickerListSearchValue = ticker;
            }
            for (const dateString of dateStringList.reverse()) {
                try {
                    // console.log(`Fetching trades for ${dateString}`);
                    const url = `https://api.bullflow.io/v1/fetchHistoricalFlowData?date=${dateString}&tickers=${temptTickerListSearchValue}`;
                    const response = await axios.get(url);
                    let tradesList = response.data; // Assuming the API returns an array of trades
                    const today = new Date(tradesList[0].ut * 1000);
                    let expandedTradesList = tradesList.map(trade => miniUnpackAndCompleteTrade(trade, null, today));
                    expandedTradesList = expandedTradesList.map(trade => ({
                        ...trade,
                        id: generateID()
                    }));
                    setTrades(currentTrades => [...currentTrades, ...expandedTradesList]);
                } catch (err) {
                    console.error(`API error for date ${dateString}:`, err.message);
                }

                iteration++;
                setFetchCollectionProgress((iteration / dateListLength) * 100);
            }

            setFetchCollectionProgress(0);
            setLoading(false);
            setFirstTimeLoading(false);
        } else {
            // console.log("Error: No dates provided");
            setLoading(false);
            setIsLoading(false);
        }
    }, [dateStringList]);

    useEffect(() => {
        fetchTrades();
        return () => {
            isMountedRef.current = false;
            if (unsubscribeRef.current) {
                unsubscribeRef.current();
            }
        };
    }, [fetchTrades]);

    function useDebouncedEffect(effect, deps, delay) {
        useEffect(() => {
            const handler = setTimeout(() => effect(), delay);
            return () => clearTimeout(handler);
        }, [...deps, delay]);
    }
    const countCallPutData = (trades) => {
        // console.log(`Counting call/put data for ${trades.length} trades`);
        let callCount = 0;
        let putCount = 0;
        let callPremium = 0;
        let putPremium = 0;

        trades.forEach((trade) => {
            if (trade.ot === "C") {
                callCount += 1;
                callPremium += trade.p;
            } else {
                putCount += 1;
                putPremium += trade.p;
            }
        });
        const data = {
            callCount: callCount,
            putCount: putCount,
            callPremium: callPremium,
            putPremium: putPremium,
        };
        // console.log(`Call count: ${callCount}, Put count: ${putCount}, Call premium: ${callPremium}, Put premium: ${putPremium}`);
        setCurrentCallPutData(data);
    };


    const updateDataGridRows = () => {
        // console.log("Updating data grid rows");
        if (trades.length > 0) {
            setIsFiltering(true);
            setIsLoading(true);
        }
        countCallPutData(trades);
        // console.log(`Trades length: ${trades.length}`);
        const today = new Date();
        const thirtyMinAgo = (today.getTime() / 1000) - (30 * 60);
        let filteredTrades = [];

        if (firstTimeLoading) {
            filteredTrades = trades;
        } else {
            // console.log("Filtering trades");
            filteredTrades = trades.filter(trade => checkTradeFilter(trade, today, secondsCalc, thirtyMinAgo));
        }
        // console.log(`Filtered trades length: ${filteredTrades.length}`);

        const allGridRowData = [];
        try {
            gridApiRef.current.forEachNode((node) => allGridRowData.push(node.data));
        } catch (error) {
            console.error('Grid error');
        }

        const allRowIdsInGrid = new Set(allGridRowData.map((data) => data.id));
        const filteredTradeIds = new Set(filteredTrades.map((trade) => trade.id));

        const addsAndUpdates = filteredTrades.filter((trade) =>
            !allRowIdsInGrid.has(trade.id) || allRowIdsInGrid.has(trade.id)
        );

        const transaction = {
            add: addsAndUpdates.filter((trade) => !allRowIdsInGrid.has(trade.id)),
            update: addsAndUpdates.filter((trade) => allRowIdsInGrid.has(trade.id)),
            remove: allGridRowData.filter((data) => !filteredTradeIds.has(data.id)),
        };

        // console.log(`Transaction: ${transaction.add.length} adds, ${transaction.update.length} updates, ${transaction.remove.length} removes`);
        gridApiRef.current.applyTransaction(transaction);


        setIsLoading(false);
    };



    // useDebouncedEffect(updateDataGridRows, [trades], 100);

    const onGridReady = params => {
        gridApiRef.current = params.api;
        columnApiRef.current = params.columnApi;
    };
    useDebouncedEffect(updateDataGridRows, [
        trades,
        activeFavoriteTickers,
        filtersHidden,
        minPremium,
        maxPremium,
        minOTM,
        maxOTM,
        minScore,
        maxScore,
        minIV,
        maxIV,
        minStrike,
        maxStrike,
        minVolumeOfInterest,
        maxVolumeOfInterest,
        minCurrentVolume,
        maxCurrentVolume,
        minOI,
        maxOI,
        minSpot,
        maxSpot,
        minOptionPrice,
        maxOptionPrice,
        minTradeSize,
        maxTradeSize,
        minMarketCap,
        maxMarketCap,
        minDTE,
        maxDTE,
        excludeTickers,
        onlyShowTickers,
        callsCheckBox,
        putsCheckBox,
        aaCheckBox,
        bbCheckBox,
        bullishCheckBox,
        bearishCheckBox,
        neutralCheckBox,
        spCheckBox,
        splitsCheckBox,
        sweepsCheckBox,
        multilegCheckbox,
        singlesCheckbox,
        blocksCheckbox,
        userHasSubscription,
        sectorFilterCode,
        activeTags,
        isolatedSymbol,
        expirationUnixStart,
        expirationUnixEnd,
    ], 250);

    const checkTradeFilter = (trade, today, secondsCalc, thirtyMinAgo) => {
        if (activeTags.length > 0 && trade.tg?.length <= 0) {
            // console.log("Returning false: activeTags specified but no trade tags found");
            return false;
        }
        if (activeTags.length > 0 && trade.tg?.length > 0) {
            if (!activeTags.every(item => trade.tg.includes(item))) {
                // console.log("Returning false: activeTags not all present in trade tags");
                return false;
            }
        }

        if (activeFavoriteTickers.length > 0) {
            if (!(activeFavoriteTickers.includes(trade.tsy) || activeFavoriteTickers.includes(trade.sym))) {
                // console.log("Returning false: trade.tsy not in activeFavoriteTickers");
                return false;
            }
        }


        let p = trade.p;

        if (isSlowMode) {
            if (HIGH_VOLUME_TICKERS_SET.has(trade.tsy) || SLOW_MODE_SPREAD_EXECUTIONS.has(trade.se)) {
                // console.log("Returning false: slow mode - high volume ticker or slow mode spread execution");
                return false;
            }
            if (trade.tt === "SWEEP" && p < 50000) {
                // console.log("Returning false: slow mode - sweep trade with premium less than 50000");
                return false;
            } else if (trade.tt === "BLOCK" && p < 100000) {
                // console.log("Returning false: slow mode - block trade with premium less than 100000");
                return false;
            }
        }

        if (isNaN(p)) {
            // console.log("Returning false: premium is NaN");
            return false;
        }
        let premiumCheck = ((minPremium ? p >= minPremium : true) && (maxPremium ? p <= maxPremium : true));
        if (!premiumCheck) {
            console.log(`Returning false: premium check failed. Premium: ${p}, minPremium: ${minPremium}, maxPremium: ${maxPremium}`);
            return false;
        }
        let op = trade.op;
        if (isNaN(op)) {
            // console.log("Returning false: option price (op) is NaN");
            return false;
        }

        let OTMCheck = ((minOTM ? op >= minOTM : true) && (maxOTM ? op <= maxOTM : true));
        if (!OTMCheck) {
            // console.log("Returning false: OTMCheck failed");
            return false;
        }

        let sc = trade.sc;
        let spot = trade.sp;
        let optionPrice = trade.tp;
        let mc = trade.mc;
        let cv = trade.cv;
        let oi = trade.oi;
        let eut = trade.eut;
        let strike = trade.stp;
        let iv = trade.iv;


        // Check each numeric field individually:
        if (isNaN(sc)) {
            // console.log("Returning false: trade.sc is NaN");
            return false;
        }
        if (spot != null && isNaN(spot)) {
            // console.log("Returning false: trade.sp is NaN");
            return false;
        }
        if (optionPrice != null && isNaN(optionPrice)) {
            // console.log("Returning false: trade.tp (optionPrice) is NaN");
            return false;
        }
        if (mc != null && isNaN(mc)) {
            // console.log("Returning false: trade.mc is NaN");
            return false;
        }
        if (cv != null && isNaN(cv)) {
            // console.log("Returning false: trade.cv is NaN");
            return false;
        }
        if (eut != null && isNaN(eut)) {
            // console.log("Returning false: trade.eut is NaN");
            return false;
        }
        if (oi != null && isNaN(oi)) {
            // console.log("Returning false: trade.oi is NaN");
            return false;
        }
        var isIVNan = false;
        if (iv != null && isNaN(iv)) {
            // console.log(`IV is nan: ${iv}`);
            isIVNan = true;
        }

        let filterOIMin = minOI;
        let filterOIMax = maxOI;

        if (filterOIMax >= MAX_OI) {
            filterOIMax = 99999999;
        }

        if (oi > filterOIMax || oi < filterOIMin) {
            console.log("OI filter failed");
            return false;
        }

        if (!(eut >= expirationUnixStart) || !(eut <= expirationUnixEnd)) {
            // console.log("Returning false: expiration timestamp filter failed");
            return false;
        }

        let filterCurrentVolumeMax = maxCurrentVolume;
        let filterCurrentVolumeMin = minCurrentVolume;
        if (filterCurrentVolumeMax >= MAX_CURRENT_VOLUME) {
            filterCurrentVolumeMax = 9999999;
        }
        if (cv > filterCurrentVolumeMax || cv < filterCurrentVolumeMin) {
            // console.log("Returning false: current volume filter failed");
            return false;
        }

        let strikeCheck = ((minStrike ? strike >= minStrike : true) && (maxStrike ? strike <= maxStrike : true));
        if (!strikeCheck) {
            console.log(`Returning false: strike check failed. Strike: ${strike}, minStrike: ${minStrike}, maxStrike: ${maxStrike}. Trade doc name: ${trade.tdn} sym: ${trade.sym}`);
            return false;
        }
        if (!isIVNan) {
            if (iv > MAX_IMPLIED_VOLATILITY) {
                iv = MAX_IMPLIED_VOLATILITY;
            }
            let ivCheck = ((minIV ? iv >= minIV : true) && (maxIV ? iv <= maxIV : true));
            if (!ivCheck) {
                // console.log(`Returning false: iv check failed. IV: ${iv}, minIV: ${minIV}, maxIV: ${maxIV}. Trade doc name: ${trade.tdn} sym: ${trade.sym}`);
                return false;
            }
        } else {
            if (minIV != 0 && maxIV != MAX_IMPLIED_VOLATILITY) {
                // console.log(`Returning false: iv is nan and user is filtering for IV: ${iv}, minIV: ${minIV}, maxIV: ${maxIV}. Trade doc name: ${trade.tdn} sym: ${trade.sym}`);
                return false;
            }
        }
        let scCheck = ((minScore ? sc >= minScore : true) && (maxScore ? sc <= maxScore : true));
        if (!scCheck) {
            console.log(`Returning false: sc check failed. Score: ${sc}, minScore: ${minScore}, maxScore: ${maxScore}`);
            return false;
        }

        let spotCheck = ((minSpot ? spot >= minSpot : true) && (maxSpot ? spot <= maxSpot : true));
        if (!spotCheck) {
            console.log(`Returning false: spot check failed. Spot: ${spot}, minSpot: ${minSpot}, maxSpot: ${maxSpot}`);
            return false;
        }

        let optionPriceCheck = ((minOptionPrice ? optionPrice >= minOptionPrice : true) && (maxOptionPrice ? optionPrice <= maxOptionPrice : true));
        if (!optionPriceCheck) {
            // console.log("Returning false: option price check failed");
            return false;
        }

        let tsCheck = ((minTradeSize ? trade.ts >= minTradeSize : true) && (maxTradeSize ? trade.ts <= maxTradeSize : true));
        if (!tsCheck) {
            // console.log("Returning false: trade size check failed");
            return false;
        }

        let excludeCheck = excludeTickers.length > 0 ? !excludeTickers.includes(trade.tsy) : true;
        if (!excludeCheck) {
            // console.log("Returning false: exclude tickers check failed");
            return false;
        }
        let showCheck = onlyShowTickers.length > 0 ? onlyShowTickers.includes(trade.tsy) : true;
        if (!showCheck) {
            console.log("Returning false: only show tickers check failed");
            // of the first item in onlyShowTickers is an empty string, do not return false
            if (onlyShowTickers[0] === "") {
                showCheck = true;
            } else {
                return false;
            }
        }

        const min = Number.isFinite(minDTE) ? +minDTE : 0;
        const max = Number.isFinite(maxDTE) ? +maxDTE : 9999;


        const dte = trade.dte;
        if (dte < min || dte > max) {
            console.log(`Returning false: dte check failed. DTE: ${dte}, minDTE: ${minDTE}, maxDTE: ${maxDTE}`);
            return false;
        }

        if (!callsCheckBox && trade.ot === "C") {
            // console.log("Returning false: calls checkbox disabled for call trade");
            return false;
        }
        if (!putsCheckBox && trade.ot === "P") {
            // console.log("Returning false: puts checkbox disabled for put trade");
            return false;
        }

        if (!aaCheckBox && (trade.se === "Ask" || trade.se === "Above Ask")) {
            console.log(`Returning false aa: ${aaCheckBox} , executed at: ${trade.se}`);
            return false;
        }
        if (!bbCheckBox && (trade.se === "Bid" || trade.se === "Below Bid")) {
            console.log(`Returning false bb : ${bbCheckBox} , executed at: ${trade.se}`);
            return false;
        }
        if (!spCheckBox && (trade.se === "Mid")) {
            // console.log("Returning false: spCheckBox disabled for trade execution type (Mid)");
            return false;
        }
        if (!bullishCheckBox && trade.tks === 1) {
            // console.log("Returning false: bullishCheckBox disabled for bullish trade");
            return false;
        }
        if (!bearishCheckBox && trade.tks === -1) {
            // console.log("Returning false: bearishCheckBox disabled for bearish trade");
            return false;
        }
        if (!neutralCheckBox && trade.tks === 0) {
            // console.log("Returning false: neutralCheckBox disabled for neutral trade");
            return false;
        }

        if (!exDividendCheckbox && trade.ex === 1) {
            // console.log("Returning false: exDividendCheckbox disabled for ex-dividend trade");
            return false;
        }

        if (!multilegCheckbox && trade.tt === "MULTI") {
            // // console.log("Returning false: multilegCheckbox disabled for multi-leg trade");
            return false;
        }
        if (!splitsCheckBox && trade.tt === "SPLIT") {
            // console.log("Returning false: splitsCheckBox disabled for split trade");
            return false;
        }
        if (!sweepsCheckBox && trade.tt === "SWEEP") {
            // console.log("Returning false: sweepsCheckBox disabled for sweep trade");
            return false;
        }
        if (!singlesCheckbox && trade.tt === "SINGLE") {
            // console.log("Returning false: singlesCheckbox disabled for single trade");
            return false;
        }
        if (!blocksCheckbox && trade.tt === "BLOCK") {
            // console.log("Returning false: blocksCheckbox disabled for block trade");
            return false;
        }

        if (sectorFilterCode !== "12" && (sectorFilterCode !== trade.s)) {
            console.log(`Returning false: sector filter failed. trade code: ${trade.s}, filter code: ${sectorFilterCode}`);
            return false;
        }

        if (isolatedSymbol != "") {
            if (trade.sym != isolatedSymbol) {
                // console.log("Returning false: isolatedSymbol filter did not match trade symbol");
                return false;
            }
        }
        return premiumCheck && OTMCheck && excludeCheck && showCheck && scCheck && spotCheck && optionPriceCheck;
    };



    const handleTickerSearchInputChange = (value) => {
        if (value === "") {
            onTickerSearchClear();
        } else {
            setSearchInputValue(value);
        }
    };

    const handleTickerListSearchInputChange = (value) => {
        if (value === "") {
            // onTickerSearchClear();
        } else {
            setTickerListSearchValue(value);
        }
    };

    const onTickerSearchEnter = () => {
        setIsolatedSymbol("");
        setOnlyShowTickers([searchInputValue]);
        setTickerForData(searchInputValue);
        setIsSearching(true);
    };

    const onTickerSearchClear = () => {
        setIsolatedSymbol("");
        setTickerForData("");
        setOnlyShowTickers([]);
        setIsSearching(false);
        setSearchInputValue("");
        closeRowDropdown();
    };

    const onTickerListSearchClear = () => {
        setTickerListSearchValue("");
    };

    const handleSelectionChange = (newSelectedChips) => {
        setActiveTags(newSelectedChips);
    };


    const handleFavoriteTickerChange = (tickers) => {
        console.log("Favorite tickers: ", tickers);
        setActiveFavoriteTickers(tickers);
    }

    const toggleSlowMode = () => {
        setIsSlowMode(!isSlowMode);
    };


    const clearFilters = () => {
        setIsolatedSymbol("");
        setVolOverOI(false);
        setMinPremium(9999);
        setMaxPremium(MAX_PREMIUM);
        setMinDTE(0);
        setMaxDTE(MAX_DTE);
        setOnlyShowTickers([]);
        setExcludeTickers([]);
        setMinOTM(-3000);
        setMaxOTM(3000);
        setMinScore(0.0);
        setMaxScore(1.0);
        setMinVolumeOfInterest(0);
        setMaxVolumeOfInterest(100);
        setMinCurrentVolume(0);
        setMaxCurrentVolume(MAX_CURRENT_VOLUME);
        setMinOI(0);
        setMaxOI(MAX_OI);
        setMinStrike(0);
        setMaxStrike(MAX_STRIKE_PRICE);
        setMinIV(0);
        setMaxIV(MAX_IMPLIED_VOLATILITY);
        setExpirationUnixStart(0);
        setExpirationUnixEnd(99999999999999);
        setMinSpot(0);
        setMaxSpot(7500);
        setMinOptionPrice(0);
        setMaxOptionPrice(1000000);
        setMinTradeSize(0);
        setMaxTradeSize(1000000);
        setMinVolumeDif("");
        setMaxVolumeDif("");
        setCallsCheckBox(true);
        setPutsCheckBox(true);
        setAACheckBox(true);
        setBBCheckBox(true);
        setBullishCheckBox(true);
        setBearishCheckBox(true);
        setNeutralCheckBox(true);
        setSpCheckBox(true);
        setSweepsCheckBox(true);
        setSplitsCheckBox(true);
        setSinglesCheckBox(true);
        setBlocksCheckBox(true);
        setMinMarketCap(0);
        setMaxMarketCap(99999999999999);
        setSectorFilterCode("12");
        setActiveTags([]);
        setActiveFavoriteTickers([]);
        setExpirationStartDate(null);
        setExpirationEndDate(null);
        onTickerSearchClear();
        gridApiRef.current.ensureIndexVisible(0, 'top');
        toast.success('Filters cleared');
    };


    const handleSentimentBoxChange = (value, sentimentBox) => {
        if (sentimentBox === "bullishCheckBox") {
            setBullishCheckBox(value);
        } else if (sentimentBox === "bearishCheckBox") {
            setBearishCheckBox(value);
        } else if (sentimentBox === "neutralCheckBox") {
            setNeutralCheckBox(value);
        }
        addEventToFirestore("handleSentimentBoxChange", user && user.email ? user.email : "");
        window.gtag('event', 'handleSentimentBoxChange', {
            'event_category': 'Button',
            'event_label': 'handleSentimentBoxChange',
            'value': 1
        });
    }

    const handleExecutionPriceBoxChange = (value, executionBox) => {
        if (executionBox === "aaCheckBox") {
            setAACheckBox(value);
        } else if (executionBox === "bbCheckBox") {
            setBBCheckBox(value);
        } else {
            setSpCheckBox(value);
        }
        addEventToFirestore("handleExecutionPriceBoxChange", user && user.email ? user.email : "");
        window.gtag('event', 'handleExecutionPriceBoxChange', {
            'event_category': 'Button',
            'event_label': 'handleExecutionPriceBoxChange',
            'value': 1
        });
    }
    const handleTradeSweepChange = (value, tradeOrSweepBox) => {
        if (tradeOrSweepBox === "splitsCheckbox") {
            setSplitsCheckBox(value);
        } else if (tradeOrSweepBox === "blocksCheckbox") {
            setBlocksCheckBox(value);
        } else if (tradeOrSweepBox === "sweepsCheckbox") {
            setSweepsCheckBox(value);
        } else if (tradeOrSweepBox === "multiLegCheckbox") {
            setMultilegCheckbox(value);
        }

        addEventToFirestore("handleTradeSweepChange", user && user.email ? user.email : "");
        window.gtag('event', 'handleTradeSweepChange', {
            'event_category': 'Button',
            'event_label': 'handleTradeSweepChange',
            'value': 1
        });
    }

    const handleFilterNameChange = (value) => {
        setFilterNameValue(value);
    };

    const handleAlertNameChange = (value) => {
        setAlertNameValue(value);
        addEventToFirestore("handleAlertNameChange", user && user.email ? user.email : "");
        window.gtag('event', 'handleAlertNameChange', {
            'event_category': 'Button',
            'event_label': 'handleAlertNameChange',
            'value': 1
        });
    };


    const handleOTMFilterChange = (field, value) => {
        if (field === 'min OTM') {
            setMinOTM(value);
        } else if (field === 'max OTM') {
            setMaxOTM(value);
        } else {
            console.error("Filter error 76090");
        }
    }
    const handleScoreFilterChange = (field, value) => {
        if (field === 'min Score') {
            setMinScore(value);
        } else if (field === 'max Score') {
            setMaxScore(value);
        } else {
            console.error("Filter error 77155");
        }
    }

    const handleStrikeFilterChange = (field, value) => {
        if (field === 'min strike') {
            setMinStrike(value);
        } else if (field === 'max strike') {
            setMaxStrike(value);
        } else {
            console.error("Filter error 70155");
        }
    }

    const handleIVFilterChange = (field, value) => {
        if (field === 'min IV') {
            setMinIV(value);
        } else if (field === 'max IV') {
            setMaxIV(value);
        } else {
            console.error("Filter error 70155");
        }
    }

    const handleCurrentVolumeFilterChange = (values) => {
        setMinCurrentVolume(values.min);
        setMaxCurrentVolume(values.max);
    }

    const handleVolumeOfInterestFilterChange = (values) => {
        setMinVolumeOfInterest(values.min);
        setMaxVolumeOfInterest(values.max);
    }

    const handleOIFilterChange = (values) => {
        setMinOI(values.min);
        setMaxOI(values.max);
    }

    const handleSpotFilterChange = (field, value) => {
        if (field === 'min spot') {
            setMinSpot(value);
        } else if (field === 'max spot') {
            setMaxSpot(value);
        } else {
            console.error("Filter error 70155");
        }
    }

    const handleOptionPriceFilterChange = (field, value) => {
        if (field === 'min option price') {
            setMinOptionPrice(value);
        } else if (field === 'max option price') {
            setMaxOptionPrice(value);
        } else {
            console.error("Filter error 70115");
        }
    }

    const handleTradeSizeFilterChange = (field, value) => {
        console.log(`Field: ${field}, Value: ${value}`);
        if (field === 'min trade size') {
            setMinTradeSize(value);
        } else if (field === 'max trade size') {
            setMaxTradeSize(value);
        } else {
            console.error("Filter error 202455");
        }
    }


    const handleMarketCapFilterChange = (field, value) => {
        if (field === 'min market cap') {
            setMinMarketCap(value);
        } else if (field === 'max market cap') {
            setMaxMarketCap(value);
        } else {
            console.error("Filter error 70199");
        }
    }

    const handleExpirationFilterChange = (field, value) => {
        if (field === 'min DTE') {
            setMinDTE(value);
        } else if (field === 'max DTE') {
            setMaxDTE(value);
        }
    };
    const handleCallPutChange = (value, callOrPutBox) => {
        if (callOrPutBox === "callsCheckbox") {
            setCallsCheckBox(value);
        } else {
            setPutsCheckBox(value);
        }
        addEventToFirestore("handleCallPutChange", user && user.email ? user.email : "");
        window.gtag('event', 'handleCallPutChange', {
            'event_category': 'Button',
            'event_label': 'handleCallPutChange',
            'value': 1
        });
    };
    const handlePremiumFilterChange = (field, value) => {
        if (field === 'min') {
            setMinPremium(value);
        } else if (field === 'max') {
            setMaxPremium(value);
        } else {
            console.error("Error code 55312");
        }
    };

    const handleSectorFilterChange = (e) => {
        setSectorFilterCode(getSectorCode(e));
        console.log(`Sector filter: ${e}`);
        console.log(`Sector code: ${getSectorCode(e)}`);
        addEventToFirestore("handleSectorDropDownChange", user && user.email ? user.email : "");
        window.gtag('event', 'handleSectorDropDownChange', {
            'event_category': 'Button',
            'event_label': 'handleSectorDropDownChange',
            'value': 1
        });
    };


    const handleCollectionDateRangeChange = (dates, dateStrings) => {
        setHasSelectedDateRange(true);
        setTrades([]);
        if (!dates) {
            console.log('No dates selected');
            return;
        }
        const startDate = dates[0].toDate();
        const endDate = dates[1].toDate();

        const collectionNames = generateCollectionNames(startDate, endDate);
        setCollectionList(collectionNames);
    };

    const handleCollectionDateRangeChange2 = (dates, dateStrings) => {
        // console.log("Changing date range")
        setHasSelectedDateRange(true);
        setTrades([]);
        if (!dates) {
            console.log('No dates selected');
            return;
        }
        const startDate = dates[0].toDate();
        const endDate = dates[1].toDate();

        const collectionNames = generateDateNames(startDate, endDate);
        setDateStringList(collectionNames);
    };


    const handleFilterDropdownChange = (e) => {
        const value = e.target.value;
        const selectedItem = filterItems[value];

        console.log(`Selected item: ${JSON.stringify(selectedItem)}`);

        if (!selectedItem) {
            console.error(`No filter item found with key: ${value}`);
            return;
        }

        // — numeric/range fields (unchanged) —
        setMinPremium(selectedItem.minPremium ? selectedItem.minPremium : 0);
        setMaxPremium(selectedItem.maxPremium ? selectedItem.maxPremium : MAX_PREMIUM);
        setMinDTE(selectedItem.minDTE ? selectedItem.minDTE : 0);
        setMaxDTE(selectedItem.maxDTE ? selectedItem.maxDTE : MAX_DTE);
        setOnlyShowTickers(selectedItem.onlyShowTickers);
        setExcludeTickers(selectedItem.excludeTickers);
        setMinOTM(selectedItem.minOTM ? selectedItem.minOTM : -3000);
        setMaxOTM(selectedItem.maxOTM ? selectedItem.maxOTM : 3000);
        setMinScore(selectedItem.minScore ? selectedItem.minScore : 0.0);
        setMaxScore(selectedItem.maxScore ? selectedItem.maxScore : 1.0);
        setMinCurrentVolume(selectedItem.minCurrentVolume ? selectedItem.minCurrentVolume : 0);
        setMaxCurrentVolume(selectedItem.maxCurrentVolume ? selectedItem.maxCurrentVolume : MAX_CURRENT_VOLUME);
        setMinOI(selectedItem.minOI ? selectedItem.minOI : 0);
        setMaxOI(selectedItem.maxOI ? selectedItem.maxOI : MAX_OI);
        setExpirationUnixStart(selectedItem.expirationUnixStart ? selectedItem.expirationUnixStart : 0);
        setExpirationUnixEnd(selectedItem.expirationUnixEnd ? selectedItem.expirationUnixEnd : 99999999999999);
        setMinStrike(selectedItem.minStrike ? selectedItem.minStrike : 0);
        setMaxStrike(selectedItem.maxStrike ? selectedItem.maxStrike : MAX_STRIKE_PRICE);
        setMinIV(selectedItem.minIV ? selectedItem.minIV : 0);
        setMaxIV(selectedItem.maxIV ? selectedItem.maxIV : MAX_IMPLIED_VOLATILITY);
        // — boolean checkboxes: default to true if null or undefined —
        setCallsCheckBox(selectedItem.callsCheckBox ?? true);
        setPutsCheckBox(selectedItem.putsCheckBox ?? true);
        setAACheckBox(selectedItem.aaCheckBox ?? true);
        setBBCheckBox(selectedItem.bbCheckBox ?? true);
        setBullishCheckBox(selectedItem.bullishCheckBox ?? true);
        setBearishCheckBox(selectedItem.bearishCheckBox ?? true);
        setNeutralCheckBox(selectedItem.neutralCheckBox ?? true);
        setSpCheckBox(selectedItem.spCheckBox ?? true);
        setSweepsCheckBox(selectedItem.sweepsCheckBox ?? true);
        setSplitsCheckBox(selectedItem.splitsCheckBox ?? true);
        setMultilegCheckbox(selectedItem.multilegCheckbox ?? true);
        setExDividendCheckBox(selectedItem.exDividendCheckbox ?? true);
        setBlocksCheckBox(selectedItem.blocksCheckbox ?? true);
        setSinglesCheckBox(selectedItem.singlesCheckbox ?? true);

        // — other fields (unchanged) —
        setMinSpot(selectedItem.minSpot ? selectedItem.minSpot : 0);
        setMaxSpot(selectedItem.maxSpot ? selectedItem.maxSpot : MAX_SPOT_PRICE);

        if (selectedItem.sector.length >= 3) {
            setSectorFilterCode(getSectorCode(selectedItem.sector));
        } else {
            setSectorFilterCode(selectedItem.sector);
        }

        setActiveTags(selectedItem.activeTags ? selectedItem.activeTags : []);
        setMinTradeSize(selectedItem.minTradeSize ? selectedItem.minTradeSize : 0);
        setMaxTradeSize(selectedItem.maxTradeSize ? selectedItem.maxTradeSize : 1000000);
        setMinOptionPrice(selectedItem.minOptionPrice ? selectedItem.minOptionPrice : 0);
        setMaxOptionPrice(selectedItem.maxOptionPrice ? selectedItem.maxOptionPrice : 1000000);

        // — analytics —
        addEventToFirestore("handleFilterDropdownChange", user?.email || "");
        window.gtag('event', 'handleFilterDropdownChange', {
            event_category: 'Button',
            event_label: 'handleFilterDropdownChange',
            value: 1
        });
    };
    const handleTickerFilterChange = (field, value) => {
        const valueWithCommas = value.replace(/\s+/g, ',');
        const tickerArray = valueWithCommas.toUpperCase().split(',').map(ticker => ticker.trim());
        if (field === 'exclude') {
            if (valueWithCommas.trim() === '') {
                setExcludeTickers([]);
            } else {
                setExcludeTickers(tickerArray);
            }
        } else if (field === 'onlyShow') {
            if (valueWithCommas.trim() === '') {
                setOnlyShowTickers([]);
            } else {
                setOnlyShowTickers(tickerArray);
            }
        }
    };
    const trendingAlertsButtonClick = () => {
        addEventToFirestore("Trending alerts button clicked", user && user.email ? user.email : "");
        window.gtag('event', 'Trending alerts button clicked', {
            'event_category': 'Button',
            'event_label': 'Trending alerts button clicked',
            'value': 1
        });
        if (isFilterDrawerOpen) {
            setIsFilterDrawerOpen(false);
            setTimeout(() => {
                setIsTrendingAlertsOpen(!isTrendingAlertsOpen);
            }, 1000);
        } else {
            setIsTrendingAlertsOpen(!isTrendingAlertsOpen);
        }

    };
    async function downloadCollectionsAsCSV() {
        toast('Downloading', {
            duration: 7500,
            style: {
                background: 'black',
                color: 'white',
            },
            icon: <Download size={18} />,
        });
        const today = new Date();
        const thirtyMinAgo = (today.getTime() / 1000) - (30 * 60);
        let counter = parseInt(localStorage.getItem('downloadCSVCounter')) || 0;
        if (counter > 50) {
            console.log("Download limit reached.");
            return; // Stop the function if the limit is exceeded
        }

        localStorage.setItem('downloadCSVCounter', counter + 1);

        window.gtag('event', 'downloadCSV', {
            'event_category': 'Button',
            'event_label': 'downloadCSV',
            'value': 1
        });

        const fields = "sym, cv, eod, ed, iv, mc, oi, ot, op, p, sc, s, sp, se, stp, tsy, tks, tp, ts, tt, ut, edf";
        const fieldsArray = fields.split(', ').map(item => item.trim());

        let allData = [];

        try {
            // Filter the trades first
            const filteredTrades = trades.filter(trade => checkTradeFilter(trade, today, secondsCalc, thirtyMinAgo));

            let data = filteredTrades.map(rowData => {
                // Populate eod_performance with "N/A" if it does not exist
                if (!rowData.hasOwnProperty('eod_performance')) {
                    rowData['eod_performance'] = 'N/A';
                }

                // Iterate over each key in the document and replace commas in its value
                Object.keys(rowData).forEach(key => {
                    if (typeof rowData[key] === 'string') {
                        rowData[key] = rowData[key].replace(/,/g, ' '); // Replace commas with a space
                    }
                });
                return rowData;
            });

            if (fieldsArray) {
                data = data.map(row => {
                    return fieldsArray.reduce((acc, key) => {
                        acc[key] = row[key] || 'N/A'; // Ensure all fields are populated
                        return acc;
                    }, {});
                });
            }

            // Map the header names using keyMapping
            const mappedFieldsArray = fieldsArray.map(field => keyMapping[field] || field);

            // Map the keys in each data object to their mapped header names
            data = data.map(row => {
                let newRow = {};
                fieldsArray.forEach((field, index) => {
                    const mappedField = mappedFieldsArray[index];
                    newRow[mappedField] = row[field] || 'N/A';
                });
                return newRow;
            });

            allData = allData.concat(data);

            // Convert to CSV
            const csvContent = convertToCSV(allData, mappedFieldsArray);

            // Trigger CSV download
            triggerCSVDownload(csvContent, `downloaded_alg2_trades.csv`);

        } catch (error) {
            console.error("Error handling local data: ", error);
        }
    }


    const fetchFilters = async () => {
        try {
            if (user != null) {
                const querySnapshot = await getDocs(query(
                    collection(firestore, 'custom_filters'),
                    where('userEmail', '==', user && user.email ? user.email : ""))
                );
                let fetchedItems = {};
                querySnapshot.forEach(doc => {
                    const data = doc.data();
                    fetchedItems[data.filterName] = { ...data, id: doc.id };
                });
                setFilterItems(fetchedItems);
                const filterNames = Object.keys(fetchedItems);
                setFilterNames(filterNames);
            } else {
                console.error("User error 183801");
            }
        } catch (error) {
            console.error('Error code 61838: ', error);
        }
    };
    const handleDateRangeChange = (dates, dateStrings) => {
        if (!dates) {
            setExpirationStartDate(null);
            setExpirationEndDate(null);
            setExpirationUnixStart(0);
            setExpirationUnixEnd(99999999999999);
            console.log('No dates selected');
            return;
        }

        if (dates) {
            setExpirationStartDate(dates[0]);
            setExpirationEndDate(dates[1]);
        } else {
            setExpirationStartDate(null);
            setExpirationEndDate(null);
        }

        // Function to parse date strings and set to 11:59:00 PM EST
        const parseDateToEST = (dateString) => {
            const [year, month, day] = dateString.split('-').map(Number);
            const date = new Date(Date.UTC(year, month - 1, day));

            // Move to the next day to adjust for EST (UTC-5)
            date.setUTCDate(date.getUTCDate() + 1);
            // Set time to 04:59:00 AM UTC (which is 11:59:00 PM EST of the previous day)
            date.setUTCHours(4, 59, 0, 0);

            return date;
        };

        // Create Date objects for start and end dates
        const startDate = parseDateToEST(dateStrings[0]);
        const endDate = parseDateToEST(dateStrings[1]);

        // Convert to Unix timestamps in seconds
        const expirationUnixStart = Math.floor(startDate.getTime() / 1000);
        const expirationUnixEnd = Math.floor(endDate.getTime() / 1000);

        // Set the state for expirationUnixStart and expirationUnixEnd
        setExpirationUnixStart(expirationUnixStart);
        setExpirationUnixEnd(expirationUnixEnd);

        // console.log('Expiration Unix Start:', expirationUnixStart);
        // console.log('Expiration Unix End:', expirationUnixEnd);
    };

    const deleteFilter = async (filterName) => {
        window.gtag('event', 'Delete filter', {
            'event_category': 'Button',
            'event_label': 'Delete filter',
            'value': 1
        });
        addEventToFirestore("Delete filter", user && user.email ? user.email : "");

        try {
            if (user != null) {
                const filterDocId = filterItems[filterName].id;

                if (!filterDocId) {
                    console.error('Document ID not found for the filter:', filterName);
                    return;
                }

                const filterDoc = doc(firestore, 'custom_filters', filterDocId);
                await deleteDoc(filterDoc);

                setFilterItems(prevItems => {
                    const updatedItems = { ...prevItems };
                    delete updatedItems[filterName];
                    return updatedItems;
                });

                setFilterNames(prevNames => prevNames.filter(name => name !== filterName));
                setSelectedItem('Filters');
                clearFilters();
                fetchFilters();
            } else {
                console.error("User error 567391");
            }
        } catch (error) {
            console.error('Error deleting filter: ', error);
        }
    };

    const handleAlertDelete = async (alertName) => {
        // Update the state without the deleted alert
        setAlertItems(currentAlertItems => {
            const { [alertName]: value, ...remainingAlerts } = currentAlertItems;
            return remainingAlerts;
        });
        const updatedAlertItems = { ...alertItemsRef.current };
        delete updatedAlertItems[alertName];
        alertItemsRef.current = updatedAlertItems;
    };

    const handleSave = async () => {
        addEventToFirestore("handleSave", user && user.email ? user.email : "");
        window.gtag('event', 'handleSave', {
            'event_category': 'Button',
            'event_label': 'handleSave',
            'value': 1
        });
        if (user != null) {
            const docData = {
                filterName: filterNameValue,
                userEmail: user.email,
                minPremium: minPremium,
                maxPremium: maxPremium,
                excludeTickers: excludeTickers,
                onlyShowTickers: onlyShowTickers,
                minDTE: minDTE,
                maxDTE: maxDTE,
                minOTM: minOTM,
                maxOTM: maxOTM,
                minScore: minScore,
                maxScore: maxScore,
                minStrike: minStrike,
                maxStrike: maxStrike,
                minIV: minIV,
                maxIV: maxIV,
                minVolumeOfInterest: minVolumeOfInterest,
                maxVolumeOfInterest: maxVolumeOfInterest,
                minCurrentVolume: minCurrentVolume,
                maxCurrentVolume: maxCurrentVolume,
                minOI: minOI,
                maxOI: maxOI,
                expirationUnixStart: expirationUnixStart,
                expirationUnixEnd: expirationUnixEnd,
                callsCheckBox: callsCheckBox,
                putsCheckBox: putsCheckBox,
                aaCheckBox: aaCheckBox,
                bbCheckBox: bbCheckBox,
                bullishCheckBox: bullishCheckBox,
                bearishCheckBox: bearishCheckBox,
                neutralCheckBox: neutralCheckBox,
                spCheckBox: spCheckBox,
                singlesCheckbox: singlesCheckbox,
                sweepsCheckBox: sweepsCheckBox,
                splitsCheckBox: splitsCheckBox,
                multilegCheckbox: multilegCheckbox,
                blocksCheckbox: blocksCheckbox,
                minSpot: minSpot,
                maxSpot: maxSpot,
                minOptionPrice: minOptionPrice,
                maxOptionPrice: maxOptionPrice,
                minTradeSize: minTradeSize,
                maxTradeSize: maxTradeSize,
                minVolumeDif: minVolumeDif,
                maxVolumeDif: maxVolumeDif,
                minMarketCap: minMarketCap,
                maxMarketCap: maxMarketCap,
                sector: sectorFilterCode,
                activeTags: activeTags,
                timestamp: serverTimestamp()
            };

            try {
                await addDoc(collection(firestore, 'custom_filters'), docData);
                toast.success('Filter saved successfully');
            } catch (error) {
                toast('Error saving filter');
                console.error('Error code 81723: ', error);
            }
            closeSaveDialog();
            fetchFilters();
        } else {
            auth.signOut();
            navigate('/');
        }
        setFilterNameValue("");
    };

    const saveAlert = async () => {
        addEventToFirestore(`Save alert ${alertNameValue}`, user && user.email ? user.email : "");
        window.gtag('event', 'Create alert button', {
            'event_category': 'Button',
            'event_label': 'Create alert',
            'value': 1
        });
        if (user != null) {
            const docData = {
                alertName: alertNameValue,
                userEmail: user.email,
                minPremium: minPremium,
                maxPremium: maxPremium,
                excludeTickers: excludeTickers,
                onlyShowTickers: onlyShowTickers,
                minDTE: minDTE,
                maxDTE: maxDTE,
                minOTM: minOTM,
                maxOTM: maxOTM,
                minScore: minScore,
                maxScore: maxScore,
                minStrike: minStrike,
                maxStrike: maxStrike,
                minIV: minIV,
                maxIV: maxIV,
                minVolumeOfInterest: minVolumeOfInterest,
                maxVolumeOfInterest: maxVolumeOfInterest,
                minCurrentVolume: minCurrentVolume,
                maxCurrentVolume: maxCurrentVolume,
                minOI: minOI,
                maxOI: maxOI,
                expirationUnixStart: expirationUnixStart,
                expirationUnixEnd: expirationUnixEnd,
                callsCheckBox: callsCheckBox,
                putsCheckBox: putsCheckBox,
                aaCheckBox: aaCheckBox,
                bbCheckBox: bbCheckBox,
                bullishCheckBox: bullishCheckBox,
                bearishCheckBox: bearishCheckBox,
                neutralCheckBox: neutralCheckBox,
                spCheckBox: spCheckBox,
                singlesCheckbox: singlesCheckbox,
                sweepsCheckBox: sweepsCheckBox,
                splitsCheckBox: splitsCheckBox,
                blocksCheckbox: blocksCheckbox,
                multilegCheckbox: multilegCheckbox,
                minSpot: minSpot,
                maxSpot: maxSpot,
                minOptionPrice: minOptionPrice,
                maxOptionPrice: maxOptionPrice,
                minTradeSize: minTradeSize,
                maxTradeSize: maxTradeSize,
                minVolumeDif: minVolumeDif,
                maxVolumeDif: maxVolumeDif,
                minMarketCap: minMarketCap,
                maxMarketCap: maxMarketCap,
                sector: sectorFilterCode,
                activeTags: activeTags,
                timestamp: serverTimestamp()
            };
            try {
                await addDoc(collection(firestore, '_custom_alerts'), docData);
            } catch (error) {
                console.error('Error code 81723: ', error);
            }
            closeSaveAlertDialog();
            toast('Alert saved successfully');
            fetchAlerts();
        } else {
            console.error("User error 274818");
        }
        setAlertNameValue("");
    }
    const closeTradeInfo = () => {
        setTradeInfoDialog(false);
    };
    const toggleSaveDialog = () => {
        setOpenSaveDialog(true);
    };
    const closeSaveDialog = () => {
        setOpenSaveDialog(false);
    };
    const toggleSaveAlertDialog = () => {
        setOpenSaveAlertDialog(true);
    };
    const closeSaveAlertDialog = () => {
        setOpenSaveAlertDialog(false);
    };
    const closeSpotTradingView = () => {
        setOpenSpotTradingView(false);
    };
    const closeOptionPriceChart = () => {
        setOpenOptionPriceChart(false);
    };
    const closeNetPremiumChart = () => {
        setOpenNetPremiumChart(false);
    };
    const closeAccountSettings = () => {
        setAccountSettingsDialog(false);
    };
    const NoRowsTemplate = ({ hasSelectedDateRange, loading }) => {
        const tradingHours = isTradingDay(actualToday) && isTradingHours();

        let template = ``;

        if (!hasSelectedDateRange) {
            template = `
            <div style="padding: 10px; border-radius: 8px; background-color: #333; color: white; text-align: center;">
              Select a date range to view historical flow
            </div>
          `;
        } else if (loading) {
            template = `
            <div style="padding: 10px; border-radius: 8px; background-color: #333; color: white; text-align: center;">
             Loading...
            </div>
          `;
        } else {
            template = `
            <div style="padding: 10px; border-radius: 8px; background-color: #333; color: white; text-align: center;">
              No matching trades for the selected filters
            </div>
          `;
        }

        return template;
    };
    const isPhoneSize = useMediaQuery({ query: '(max-width: 768px)' });
    const getRowClass = useCallback((params) => {
        const { ic = false, ios = false } = params.data;

        if (ic) {
            return 'canceled-row';
        }
        if (ios) {
            return 'out-of-sequence-row';
        }
        return '';
    }, []);


    if (isPhoneSize) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px', background: '#333', borderRadius: '10px', margin: '20px' }}>
                <div style={{ textAlign: 'center' }}>
                    <img src={Bull} alt="Bullflow Logo" style={{ width: '50px', height: '50px', display: 'block', margin: '0 auto 20px' }} />
                    <p style={{ color: '#f0f0f0', fontSize: '1.2em', margin: '0 0 20px 0' }}>
                        Download the Bullflow app now for the best experience!
                    </p>
                    <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
                        <a href="https://play.google.com/store/apps/details?id=io.bullflow.bullflow" target="_blank" rel="noopener noreferrer">
                            <img
                                src="https://www.aps.edu/students-parents/images/downloadOnTheGooglePlayStoreBadge.png/image"
                                alt="Download on Google Play"
                                style={{ width: '150px', height: 'auto' }}
                            />
                        </a>
                        <a href="https://apps.apple.com/us/app/bullflow-live-options-flow/id6741772392" target="_blank" rel="noopener noreferrer">
                            <img
                                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSvzJASvP_DUtrXr3e-pFLajZYQ8NUOP-g46g&s"
                                alt="Download on App Store"
                                style={{ width: '150px', height: 'auto' }}
                            />
                        </a>
                    </div>
                </div>
            </div>
        );
    } else {

        return (

            <div style={{ height: '100vh', width: '100vw', display: 'flex', flexDirection: 'row', background: '#1a1b20' }}>
                <style>
                    {`
          .canceled-row {
            background-color: #ff525840;
          }
          .out-of-sequence-row {
            background-color: #42f5d425;
          }
        `}
                </style>
                <Helmet>
                    <title>Historical Flow</title>
                    <meta name="description" content="Bullflow historical flow." />
                </Helmet>
                <Toaster
                    toastOptions={{
                        style: {
                            background: '#333',
                            color: 'white'
                        }
                    }} />
                {/* Left nav column with logo and icons */}
                <Sidebar activeItem="historical-flow" />

                {/* Center column with Title row, details, Ag grid */}
                <div style={{ backgroundColor: '#1a1b20', flex: 1, marginRight: '20px', marginTop: '10px', marginLeft: '20px', marginBottom: '20px', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center' }}>
                    {
                        cancelAt !== null && (
                            <Alert
                                message={`Your subscription will expire in ${cancelAt} days. Keep your access to powerful real-time options flow by renewing you subscription! Enjoy 35% off your first month with code: RENEW35`}
                                type="warning"
                                showIcon
                                style={{ width: '100%', textAlign: 'center', marginBottom: '4px', marginTop: '4px' }}
                                closable
                                action={
                                    <AntButton
                                        style={{ backgroundColor: '#FFD700', color: '#000', marginRight: '10px' }}
                                        onClick={() => {
                                            window.gtag('event', 'Renew Subscription portal button', {
                                                'event_category': 'Button',
                                                'event_label': 'Renew Subscription portal button',
                                                'value': 1
                                            });
                                            addEventToFirestore("Renew Subscription portal button", user && user.email ? user.email : "");
                                            window.open(`https://billing.stripe.com/p/login/00g4jA2096o86FW288?prefilled_email=${user && user.email ? user.email : ""}`, '_blank');
                                        }} size="small" type="primary">
                                        Renew
                                    </AntButton>
                                }
                            />
                        )
                    }
                    {/* Top Bar */}
                    <div style={{ width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', margin: 0, padding: 0 }}>
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '5px' }}>
                            <h1 style={{ color: 'white', margin: 0, fontWeight: 'bold', fontSize: '1.35em' }}>Historical Flow</h1>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '5px' }}>
                            <TickerSearchBox
                                onChange={handleTickerSearchInputChange}
                                onEnter={userHasSubscription ? onTickerSearchEnter : showSignupNotif}
                                onClear={onTickerSearchClear}
                                initialInputValue={searchInputValue}
                            />
                            <ClearIsolatedContractButton
                                onClick={() => setIsolatedSymbol("")}
                                isolatedSymbol={isolatedSymbol}
                            />
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px' }}>
                            <DownloadIconButton onClick={() => downloadCollectionsAsCSV()} />
                            <SoundIconButton onClick={() => setIsSoundOn(!isSoundOn)} isSoundOn={isSoundOn} />
                            <ResetIconButton onClick={clearFilters} />
                            <FilterIconButton onClick={userHasSubscription ? toggleDrawer : showSignupNotif} />
                        </div>
                    </div>

                    {/* 
                    <div style={{ marginTop: '10px', width: '100%', height: '140px', display: 'flex', flexDirection: 'row', gap: '10px', borderRadius: '10px', position: 'relative', overflow: 'hidden', flexShrink: 0, minHeight: '140px', minWidth: '100%' }}>
                        {userHasSubscription ? (
                            <MarketDetailsComponent isSearching={isSearching} ticker={tickerForData} />
                        ) : (
                            <NoSubTopBarComponent />
                        )}
                        <ChipFilterComponent selectedChips={activeTags} onSelectionChange={userHasSubscription ? handleSelectionChange : showSignupNotif} />
                    </div> */}

                    {/* Detail bar: */}
                    <div style={{
                        marginTop: '10px',
                        width: '100%',
                        height: '150px', // Increased height to accommodate the search box
                        display: 'flex',
                        flexDirection: 'column', // Changed to column to stack search box and other components
                        gap: '10px',
                        borderRadius: '10px',
                        position: 'relative',
                        overflow: 'hidden',
                        padding: '10px' // Optional: Add padding for inner spacing
                    }}>

                        {/* Detail bar contents */}
                        <div style={{
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'row',
                            gap: '10px',
                            borderRadius: '10px',
                            position: 'relative',
                            overflow: 'hidden'
                        }}>
                            {/* Range Picker and Download Button */}
                            <div style={{
                                flex: '1',
                                height: '100%',
                                backgroundColor: '#0e0f12',
                                borderRadius: '10px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                padding: '24px 12px',
                            }}>
                                {/* Search Box */}
                                <TickerSearchBox
                                    onChange={handleTickerListSearchInputChange}
                                    placeholder='Ticker List (optional)'
                                    onClear={onTickerListSearchClear}
                                    onEnter={
                                        () => {
                                            if (hasSelectedDateRange) {
                                                fetchTrades(tickerListSearchValue)
                                            } else {
                                                toast.error('Select a date range');
                                            }
                                        }
                                    }
                                    initialInputValue={tickerListSearchValue}
                                    fullHeight={true}
                                    placeholderFontSize='placeholder:text-[13px]'
                                    style={{
                                        width: '100%', // Ensure the search box takes full width
                                        marginBottom: '10px', // Space below the search box
                                    }}
                                />
                                <RangePicker
                                    style={{
                                        height: '100%',
                                        width: '100%', // Changed to full width for responsiveness
                                        maxWidth: '300px', // Set a maximum width
                                        backgroundColor: '#000',
                                        marginLeft: '10px',
                                    }}
                                    disabledDate={combinedDisabledDate}
                                    onChange={handleCollectionDateRangeChange2}
                                />
                                <button
                                    onClick={downloadCollectionsAsCSV}
                                    style={{
                                        marginLeft: '10px',
                                        backgroundColor: '#36363680',
                                        color: 'white',
                                        borderRadius: '24px',
                                        border: 'none',
                                        padding: '6px 12px',
                                        fontSize: '14px',
                                        cursor: 'pointer',
                                    }}>
                                    Download
                                </button>
                            </div>

                            {/* Quick Filter and Favorites */}
                            <QuickFilterAndFavoritesComponent
                                selectedQuickFilterChips={activeTags}
                                selectedFavoriteTickerChips={activeFavoriteTickers}
                                onFavoriteTickerSelectionChange={userHasSubscription ? handleFavoriteTickerChange : showSignupNotif}
                                onSelectionChange={userHasSubscription ? handleSelectionChange : showSignupNotif}
                                user={user}
                                localFavoritesList={localFavoritesList}
                                isHistoricalFlow={true}
                                style={{
                                    flex: '2' // Allocate more space to this component if needed
                                }}
                            />
                        </div>
                    </div>

                    {/* Grid */}
                    <div
                        style={gridStyle}
                        className={"ag-theme-quartz-dark"}
                        ref={gridDivRef}
                    >
                        <AgGridReact
                            columnDefs={columnDefs}
                            defaultColDef={defaultColDef}
                            sideBar={'columns'}
                            rowBuffer={5}
                            onGridReady={onGridReady}
                            getRowNodeId={gridOptions.getRowNodeId}
                            getRowId={gridOptions.getRowId}
                            headerHeight={25}
                            onRowClicked={onRowClicked}
                            ref={gridApiRef}
                            animateRows={false}
                            getRowClass={getRowClass}
                            overlayNoRowsTemplate={NoRowsTemplate({ hasSelectedDateRange, loading })}
                        />
                        {showRowDropdown && <DropdownMenu position={dropdownPosition} onClose={closeRowDropdown} />}
                    </div>
                </div>


                {/* Right Filter Drawer */}
                <div style={{
                    width: isFilterDrawerOpen ? '25%' : '0%', // Control width based on the drawer state
                    height: '100%',
                    background: '#15181d',
                    transition: 'width 0.3s ease',
                    overflowY: 'auto',
                    overflowX: 'hidden',
                }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', overflow: 'auto', marginTop: '10px' }}>
                        <Tabs
                            aria-label="Little Menu"
                            classNames={{
                                tabList: 'bg-black',
                                cursor: 'bg-neutral-800',
                                tabContent: "group-data-[selected=true]:text-white"
                            }}
                        >
                            <Tab key="Filters" title="Filters">
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', padding: '10px' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginBottom: '10px', padding: '0 10px' }}>
                                        <TextButton
                                            text="Save Filters as Alert"
                                            onClick={() => {
                                                window.gtag('event', 'Save Alert button', {
                                                    'event_category': 'Button',
                                                    'event_label': 'Save Alert button',
                                                    'value': 1
                                                });
                                                addEventToFirestore(`Click toggle save dialog`, user && user.email ? user.email : "");
                                                toggleSaveAlertDialog();
                                            }}
                                            style={{
                                                fontSize: '.65em',
                                            }}
                                        />
                                        <TextButton
                                            text="Save as Filter"
                                            onClick={() => {
                                                window.gtag('event', 'Toggle Save Dialog button', {
                                                    'event_category': 'Button',
                                                    'event_label': 'Toggle Save Dialog',
                                                    'value': 1
                                                });
                                                addEventToFirestore(`Click toggle save dialog`, user && user.email ? user.email : "");
                                                toggleSaveDialog();
                                            }}
                                            style={{
                                                fontSize: '.65em',
                                            }}
                                        />
                                    </div>
                                </div>
                                <Select
                                    size="sm"
                                    color='default'
                                    label="Select a filter"
                                    placeholder='Select a filter'
                                    selectionMode='single'
                                    onChange={handleFilterDropdownChange}
                                    width="90%"
                                >
                                    {filterNames.map((filter) => (
                                        <SelectItem key={filter} value={filter}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                {filter}
                                                <span
                                                    onClick={() => deleteFilter(filter)}
                                                    style={{ cursor: 'pointer', color: 'red', marginLeft: '20px' }}
                                                >
                                                    Delete
                                                </span>
                                            </div>
                                        </SelectItem>
                                    ))}
                                </Select>
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', overflow: 'auto', height: '185.5vh', gap: '15px', marginTop: '20px' }}>
                                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '90%' }}>
                                        <CallPutCheckBoxes callsChecked={callsCheckBox} putsChecked={putsCheckBox} handleCallPutChange={handleCallPutChange} />
                                        <SentimentCheckboxes bullishChecked={bullishCheckBox} bearishChecked={bearishCheckBox} neutralChecked={neutralCheckBox} handleSentimentBoxChange={handleSentimentBoxChange} />
                                        <ExecutionPriceCheckboxes aaChecked={aaCheckBox} bbChecked={bbCheckBox} spChecked={spCheckBox} handleExecutionPriceBoxChange={handleExecutionPriceBoxChange} />
                                        <TradesSweepsCheckBoxes splitsChecked={splitsCheckBox} sweepsChecked={sweepsCheckBox} blocksChecked={blocksCheckbox} multilegChecked={multilegCheckbox} handleTradeSweepChange={handleTradeSweepChange} />
                                    </div>
                                    <TickerFilter onlyShowTickersProp={onlyShowTickers} excludeTickersProp={excludeTickers} handleFilterChange={handleTickerFilterChange} />
                                    <RangePicker
                                        placeholder={["Expir. Start", "Expir. End"]}
                                        style={{
                                            height: '42px',
                                            width: '93.5%',
                                            backgroundColor: '#000'
                                        }}
                                        dropdownClassName="custom-dropdown-class"
                                        value={[expirationStartDate, expirationEndDate]}
                                        onChange={handleDateRangeChange}
                                    />
                                    <PremiumFilter minPremium={minPremium} maxPremium={maxPremium} handleFilterChange={handlePremiumFilterChange} />
                                    <OptionPriceFields minOptionPriceProp={minOptionPrice} maxOptionPriceProp={maxOptionPrice} handleFilterChange={handleOptionPriceFilterChange} />
                                    <TradeSizeFields minTradeSizeProp={minTradeSize} maxTradeSizeProp={maxTradeSize} handleFilterChange={handleTradeSizeFilterChange} />
                                    <VolumeOfInterestFilter minVolumePercentProp={minVolumeOfInterest} maxVolumePercentProp={maxVolumeOfInterest} handleFilterChange={handleVolumeOfInterestFilterChange} />
                                    <CurrentVolumeFilter minCurrentVolumeProp={minCurrentVolume} maxCurrentVolumeProp={maxCurrentVolume} handleFilterChange={handleCurrentVolumeFilterChange} />
                                    <OIFilter minOIProp={minOI} maxOIProp={maxOI} handleFilterChange={handleOIFilterChange} />
                                    <ScoreFilterFields minScoreProp={minScore} maxScoreProp={maxScore} handleFilterChange={handleScoreFilterChange} />
                                    <ExpirationFilterFields minDTEProp={minDTE} maxDTEProp={maxDTE} handleFilterChange={handleExpirationFilterChange} />
                                    <OTMFilterFields minOTMProp={minOTM} maxOTMProp={maxOTM} handleFilterChange={handleOTMFilterChange} />
                                    <SpotPriceFields minSpotPriceProp={minSpot} maxSpotPriceProp={maxSpot} handleFilterChange={handleSpotFilterChange} />
                                    <StrikePriceFields minStrikePriceProp={minStrike} maxStrikePriceProp={maxStrike} handleFilterChange={handleStrikeFilterChange} />
                                    <ImpliedVolatilityFields minIVProp={minIV} maxIVProp={maxIV} handleFilterChange={handleIVFilterChange} />
                                    <SectorDropDown handleDropdownChange={handleSectorFilterChange} />
                                    {/* <MarketCapFields minMarketCapProp={minMarketCap} maxMarketCapProp={maxMarketCap} handleFilterChange={handleMarketCapFilterChange} /> */}
                                    {/* <Last7DaysBullflowVolume maxLast7DaysBFVolumeProp={maxLast7DaysBFVolume} handleFilterChange={handleLast7DaysBFVolumeFilterChange} />
                                    <PrevDayBullflowVolume maxLastPrevDayBFVolumeProp={maxPrevDayBFVolume} handleFilterChange={handlePrevDayBFVolumeFilterChange} /> */}
                                </div>
                            </Tab>
                            <Tab key="Alerts" title="Alerts" style={{ width: '100%' }}>
                                <div>
                                    <AlertsListView email={user && user.email ? user.email : ""} deleteAlert={handleAlertDelete} />

                                </div>
                            </Tab>
                        </Tabs>
                    </div>
                </div>
                <Modal
                    backdrop="opaque"
                    isOpen={openSaveDialog}
                    onOpenChange={setOpenSaveDialog}
                    radius="lg"
                    classNames={{
                        body: "py-6",
                        backdrop: "bg-[#292f46]/50 backdrop-opacity-40",
                        base: "border-[#292f46] bg-[#111111] text-[#a8b0d3]",
                        header: "border-b-[1px] border-[#292f46]",
                        footer: "border-t-[1px] border-[#292f46]",
                        closeButton: "hover:bg-white/5 active:bg-white/10",
                    }}
                >
                    <ModalContent>
                        <ModalHeader>Save Filter</ModalHeader>
                        <ModalBody>
                            <GenericSearchBox
                                initialInputValue={filterNameValue}
                                onChange={handleFilterNameChange}
                                placeholder="Custom Filter Name"
                                className="w-full"
                            />
                        </ModalBody>
                        <ModalFooter>
                            <Button className="bg-[#6f4ef2] shadow-lg shadow-indigo-500/20" onPress={handleSave}>
                                Save
                            </Button>
                        </ModalFooter>
                    </ModalContent>
                </Modal>

                <Modal
                    backdrop="opaque"
                    isOpen={openSaveAlertDialog}
                    onOpenChange={setOpenSaveAlertDialog}
                    radius="lg"
                    classNames={{
                        body: "py-6",
                        backdrop: "bg-[#292f46]/50 backdrop-opacity-40",
                        base: "border-[#292f46] bg-[#111111] text-[#a8b0d3]",
                        header: "border-b-[1px] border-[#292f46]",
                        footer: "border-t-[1px] border-[#292f46]",
                        closeButton: "hover:bg-white/5 active:bg-white/10",
                    }}
                >
                    <ModalContent>
                        <ModalHeader>Save Alert</ModalHeader>
                        <ModalBody>
                            <GenericSearchBox
                                initialInputValue={alertNameValue}
                                onChange={handleAlertNameChange}
                            />
                        </ModalBody>
                        <ModalFooter>
                            <Button className="bg-[#6f4ef2] shadow-lg shadow-indigo-500/20" onPress={saveAlert}>
                                Save
                            </Button>
                        </ModalFooter>
                    </ModalContent>
                </Modal>
                <MyDialog open={openSpotTradingView} onClose={closeSpotTradingView} aria-labelledby="Trading View" aria-describedby="trading-view">
                    <DialogContent style={{ background: '#1a1b20', display: 'flex', flexDirection: 'column', alignItems: 'center', borderRadius: '10px' }}>
                        <TradingViewWidget symbol={tradingViewTicker} />
                    </DialogContent>
                </MyDialog>
                <MyDialog open={accountSettingsDialog} onClose={closeAccountSettings} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                    <DialogContent style={{ background: '#1a1b20', display: 'flex', flexDirection: 'column', alignItems: 'center', borderRadius: '10px' }}>
                        <h2 style={{ color: 'white', margin: '0 0 0 0' }}>Welcome</h2>
                        {user && <p style={{ color: 'grey', margin: '0 0 10px 0', fontSize: '.75em' }}>{user && user.email ? user.email : ""}</p>}

                        <p style={{ color: 'white', margin: '15px 0 0px 0', fontWeight: 'normal', fontSize: '0.85em', cursor: 'pointer' }}
                            onClick={
                                () => {
                                    window.gtag('event', 'Suggest a request button', {
                                        'event_category': 'Button',
                                        'event_label': 'Suggest a request',
                                        'value': 1
                                    });
                                    addEventToFirestore("Click Suggest request", user && user.email ? user.email : "");
                                    window.location.href = "mailto:support@bullflow.io?subject=New Feature Suggestion";
                                }
                            }
                        >Submit a Feature Request</p>
                        <p style={{ color: 'grey', margin: '0 0 0px 0', fontWeight: 'normal', fontSize: '0.65em', cursor: 'pointer' }}
                            onClick={
                                () => {
                                    window.gtag('event', 'Suggest a request button', {
                                        'event_category': 'Button',
                                        'event_label': 'Suggest a request',
                                        'value': 1
                                    });
                                    addEventToFirestore("Click Suggest request", user && user.email ? user.email : "");
                                    window.location.href = "mailto:support@bullflow.io?subject=New Feature Suggestion";
                                }
                            }
                        >(Simple feature requests could be implemented in just a few days)</p>

                        <p style={{ color: 'white', margin: '15px 0 0px 0', fontWeight: 'normal', fontSize: '0.85em', cursor: 'pointer' }}
                            onClick={
                                () => {
                                    window.location.href = "mailto:support@bullflow.io";
                                }
                            }
                        >Contact</p>
                        <p style={{ color: 'white', margin: '15px 0 0px 0', fontWeight: 'normal', fontSize: '0.85em', cursor: 'pointer' }}
                            onClick={
                                () => {
                                    window.gtag('event', 'Payment portal button', {
                                        'event_category': 'Button',
                                        'event_label': 'Payment portal',
                                        'value': 1
                                    });
                                    addEventToFirestore("Click Payment Portal", user && user.email ? user.email : "");
                                    window.open('https://billing.stripe.com/p/login/00g4jA2096o86FW288', '_blank');
                                }
                            }
                        >Manage Subscription</p>
                        <p style={{ color: 'white', margin: '15px 0 0px 0', fontWeight: 'normal', fontSize: '0.85em', cursor: 'pointer' }}

                            onClick={
                                () => {
                                    window.gtag('event', 'Sign out button', {
                                        'event_category': 'Button',
                                        'event_label': 'Sign out',
                                        'value': 1
                                    });
                                    addEventToFirestore("Click Sign out", user && user.email ? user.email : "");
                                    auth.signOut()
                                        .then(() => {
                                            setUserHasSubscription(false);
                                            navigate('/');
                                        })
                                        .catch((error) => {
                                            console.error("User error 22200");
                                            setUserHasSubscription(false);
                                            navigate('/');
                                        });
                                }
                            } >Sign Out</p>
                    </DialogContent>
                </MyDialog>

                <MyDialog open={tradeInfoDialog} onClose={closeTradeInfo} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                    <DialogContent style={{ background: '#1a1b20', display: 'flex', flexDirection: 'column', alignItems: 'center', borderRadius: '10px', padding: '20px', height: 'auto' }}>
                        <div background='rgb(34,26,54)' ref={myDivRef} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <h2 style={{ color: 'white', margin: '0 0 20px 0' }}>{selectedTickerForInfo && convertOptionsSymbol(selectedTickerForInfo.sym)}</h2>

                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gridGap: '20px', width: '100%', marginBottom: '20px' }}>
                                {/* Quadrant 1 */}
                                <div style={{ background: 'black', borderRadius: '10px', padding: '20px' }}>
                                    {/* <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                                        <div style={{ color: 'white' }}>Bid, Ask:</div>
                                        <div style={{ color: 'white' }}>{selectedTickerForInfo && `${selectedTickerForInfo.cb}, ${selectedTickerForInfo.ca}`}</div>
                                    </div>

                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                                        <div style={{ color: 'white' }}>Mark:</div>
                                        <div style={{ color: 'white' }}>{selectedTickerForInfo && (typeof selectedTickerForInfo.cs === 'number' ? Number(selectedTickerForInfo.cs.toFixed(2)) : 'N/A')}</div>
                                    </div> */}

                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                                        <div style={{ color: 'white' }}>Contracts:</div>
                                        <div style={{ color: 'white' }}>{selectedTickerForInfo && `${selectedTickerForInfo.ts} @ ${selectedTickerForInfo.tp}`}</div>
                                    </div>

                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                                        <div style={{ color: 'white' }}>% Return:</div>
                                        <div style={{ color: 'white', display: 'flex', alignItems: 'center', fontWeight: 'bold' }}>
                                            {selectedTickerForInfo && contractCurrentValue}
                                            {selectedTickerForInfo &&
                                                <span style={{ color: parseFloat(contractPercentChange) >= 0 ? '#02d42c' : '#fa0043', marginLeft: '5px' }}>
                                                    ({parseFloat(contractPercentChange) >= 0 ? '↑' : '↓'}{Math.abs(contractPercentChange)}%)
                                                </span>
                                            }
                                        </div>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                                        <div style={{ color: 'white' }}>OTM %:</div>
                                        <div style={{ color: 'white' }}>{selectedTickerForInfo && selectedTickerForInfo.op}%</div>
                                    </div>

                                </div>

                                {/* Quadrant 2 */}
                                <div style={{ background: 'black', borderRadius: '10px', padding: '20px' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                                        <div style={{ color: 'white' }}>Premium:</div>
                                        <div style={{ color: '#FFD700', textShadow: '0 0 10px #FFD700' }}>{selectedTickerForInfo && formatMoney(selectedTickerForInfo.p)}</div>
                                    </div>

                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                                        <div style={{ color: 'white' }}>Today's Volume:</div>
                                        <div style={{ color: 'white', display: 'flex', alignItems: 'center' }}>
                                            {selectedTickerForInfo && selectedTickerForInfo.cv}
                                        </div>
                                    </div>

                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                                        <div style={{ color: 'white' }}>Open Interest:</div>
                                        <div style={{ color: 'white' }}>{selectedTickerForInfo && selectedTickerForInfo.oi}</div>
                                    </div>

                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                                        <div style={{ color: 'white' }}>Implied Volatility:</div>
                                        <div style={{ color: 'white' }}>{selectedTickerForInfo && selectedTickerForInfo.iv}</div>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <div style={{ color: 'white' }}>Previous Volume:</div>
                                        <div style={{ color: 'white' }}>{tradeDetailsData && tradeDetailsData['p']}</div>
                                    </div>
                                </div>
                                {/* Quadrant 3 */}
                                <div style={{ background: 'black', borderRadius: '10px', padding: '20px' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                                        <div style={{ color: 'white' }}>Name:   </div>
                                        <div style={{
                                            color: 'white',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            maxWidth: '20ch'
                                        }}>
                                            {tradeDetailsData && tradeDetailsData['c']}
                                        </div>
                                    </div>

                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                                        <div style={{ color: 'white' }}>Market Cap: </div>
                                        <div style={{ color: 'white' }}>{tradeDetailsData && formatNumber(tradeDetailsData['m'])}</div>
                                    </div>

                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                                        <div style={{ color: 'white' }}>Exchange:</div>
                                        <div style={{ color: 'white' }}>{tradeDetailsData && tradeDetailsData['x']}</div>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <div style={{ color: 'white' }}>Symbol:</div>
                                        <div style={{ color: 'white' }}>{selectedTickerForInfo && selectedTickerForInfo.sym}</div>
                                    </div>
                                </div>

                                {/* Quadrant 4 */}
                                <div style={{ background: 'black', borderRadius: '10px', padding: '20px' }}>

                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                                        <div style={{ color: 'white' }}>Delta:</div>
                                        <div style={{ color: 'white' }}>{selectedTickerForInfo && selectedTickerForInfo.g && selectedTickerForInfo.g.d ? selectedTickerForInfo.g.d.toFixed(3) : '-'}</div>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                                        <div style={{ color: 'white' }}>Theta:</div>
                                        <div style={{ color: 'white' }}>{selectedTickerForInfo && selectedTickerForInfo.g && selectedTickerForInfo.g.t ? selectedTickerForInfo.g.t.toFixed(3) : '-'}</div>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                                        <div style={{ color: 'white' }}>Vega:</div>
                                        <div style={{ color: 'white' }}>{selectedTickerForInfo && selectedTickerForInfo.g && selectedTickerForInfo.g.v ? selectedTickerForInfo.g.v.toFixed(3) : '-'}</div>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <div style={{ color: 'white' }}>Rho:</div>
                                        <div style={{ color: 'white' }}>{selectedTickerForInfo && selectedTickerForInfo.g && selectedTickerForInfo.g.r ? selectedTickerForInfo.g.v.toFixed(3) : '-'}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </DialogContent>
                </MyDialog>
                <MyDialog open={openOptionPriceChart} onClose={closeOptionPriceChart} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                    <DialogContent style={{
                        background: '#1a1b20',
                        display: 'flex',
                        height: 'auto',
                        width: 'auto',
                    }}>
                        <OptionPriceChart optionsTicker_={optionPriceChartTicker} />
                    </DialogContent>
                </MyDialog>

                {/* Nextui progress bar */}
                <MyDialog open={loading} onClose={() => { }} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                    <DialogContent style={{ background: '#1a1b20', display: 'flex', flexDirection: 'column', alignItems: 'center', borderRadius: '10px', padding: '20px', height: 'auto' }}>
                        <div
                            style={{
                                width: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '20px'
                            }}
                        >
                            <p style={{ color: 'white', margin: '0 0 10px 0' }}>Loading historical flow, sit tight.</p>
                            <Progress
                                aria-label="Loading historical data... This might take some time."
                                size="md"
                                color="primary"
                                value={fetchCollectionProgress}
                            />
                        </div>
                    </DialogContent>
                </MyDialog>
                <MyDialog open={openNetPremiumChart} onClose={closeNetPremiumChart} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                    <DialogContent style={{
                        background: '#26272e',
                        display: 'flex',
                        height: 'auto',
                        width: 'auto',
                    }}>
                        <NetPremiumChart optionsTicker_={optionPriceChartTicker} />
                    </DialogContent>
                </MyDialog>
            </div >
        );
    }
};

async function fetchTradeDetails(optionsTicker, x, docId) {
    try {
        const url = `https://api.bullflow.io/v1/extraDetails?Symbol=${optionsTicker}&x=${x}&id=${docId}&date=${getDateString()}`;
        const response = await fetch(url);
        if (response.ok) {
            return await response.json();
        } else {
            console.error('There was an issue retrieving the trade details.');
            analyticsLogError('There was an issue retrieving the trade details.');
            return null;
        }
    } catch (error) {
        analyticsLogError(`trade details error: ${error}.`);
        console.error('Error gettig trade details 1877636');
        return null;
    }
}



async function fetchPreviousVolume(optionsTicker, oldSpread) {
    try {
        const url = `https://api.bullflow.io/v1/previousVolume?Symbol=${optionsTicker}`;
        const response = await fetch(url);
        if (response.ok) {
            return await response.json();
        } else {
            console.error('Error 88314 - prev volume fetch error');
            analyticsLogError('There was an issue retrieving the previous volume.');
            return null;
        }
    } catch (error) {
        analyticsLogError(`option spread error: ${error}.`);
        console.error('Error 88314 - prev volume fetch error');
        return null;
    }
}

async function fetchPercentReturn(optionsTicker, oldSpread, forHighestReturn = false, mtd = null, ut = null) {
    try {
        let url = null;
        if (forHighestReturn) {
            url = `https://api.bullflow.io/v1/highestReturn?sym=${optionsTicker}&old_price=${oldSpread}&trade_ms_of_day=${mtd}&trade_timestamp=${ut}`;
        } else {
            url = `https://api.bullflow.io/v1/spreadPercentChange?Symbol=${optionsTicker}&spread=${oldSpread}`;
        }
        // console.log(`Fetch percent return: ${url}`);
        const response = await fetch(url);
        if (response.ok) {
            return await response.json();
        } else {
            console.error('There was an issue retrieving the options spread.');

            analyticsLogError('There was an issue retrieving the options spread.');
            return null;
        }
    } catch (error) {
        analyticsLogError(`option spread error: ${error}.`);
        console.error('Error:', error);
        return null;
    }
}

async function fetchBidAskSpread(optionsTicker) {
    try {
        const url = `https://api.bullflow.io/v1/bas?Symbol=${optionsTicker}`;
        const response = await fetch(url);
        if (response.ok) {
            return await response.json();
        } else {
            console.error('There was an issue retrieving the bid ask spread.');
            analyticsLogError('There was an issue retrieving the bid ask spread.');
            return null;
        }
    } catch (error) {
        analyticsLogError(`option spread error: ${error}.`);
        console.error('Error 88314 - bas fetch error');
        return null;
    }
}


export default UpdatedHistoricalFlowDashboard;
